// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Abel&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.pagecenter {
  width: 100%;
  padding: 0 15px;
  margin: 0 auto;
}
@media only screen and (min-width: 540px) {
  .pagecenter {
    max-width: 540px;
  }
}
@media only screen and (min-width: 768px) {
  .pagecenter {
    max-width: 750px;
  }
}
@media only screen and (min-width: 992px) {
  .pagecenter {
    max-width: 960px;
  }
}
@media only screen and (min-width: 1200px) {
  .pagecenter {
    max-width: 1170px;
  }
}

.f-flex {
  display: flex;
  flex-wrap: wrap;
}

.header {
  position: relative;
  border-top: 10px solid #6D6E70;
  padding: 18px 0;
  background-color: #fff;
  z-index: 999;
}
@media only screen and (max-width: 1120px) {
  .header {
    border-top-width: 5px;
  }
}
.header__inner {
  position: relative;
  align-items: center;
}
@media only screen and (max-width: 1120px) {
  .header__inner {
    padding-right: 38px;
  }
}
@media only screen and (max-width: 767px) {
  .header__inner {
    padding-right: 35px;
  }
}
.header a:hover {
  text-decoration: none;
}
.header__logo {
  width: 270px;
}
.header__logo img {
  max-width: 100%;
}
@media only screen and (max-width: 1400px) {
  .header__logo {
    width: 200px;
  }
}
@media only screen and (max-width: 767px) {
  .header__logo {
    width: 100px;
  }
}
.header__right {
  margin-left: auto;
  align-items: center;
}
.header__right > * + * {
  margin-left: 26px;
}
@media only screen and (max-width: 1400px) {
  .header__right > * + * {
    margin-left: 16px;
  }
}
.header__search img, .header__cart img {
  width: 28px;
}
@media only screen and (max-width: 767px) {
  .header__search img, .header__cart img {
    width: 18px;
  }
}
.header__cart {
  padding: 8px 0;
  position: relative;
}
.header__cart > a {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.header__cart i {
  width: 28px;
  height: 28px;
  background-image: url("https://metjbxcucs-flywheel.netdna-ssl.com/wp-content/uploads/2020/03/foursight-cart-icon.svg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
}
.header__cart i::before {
  display: none;
}
@media only screen and (max-width: 767px) {
  .header__cart i {
    width: 18px;
    height: 18px;
  }
}
.header__cartcount {
  position: absolute;
  top: -14px;
  left: 15px;
  background-color: #7BBC43;
  color: #fff;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  line-height: 26px;
  font-size: 12px;
  font-family: "Museo-700";
  text-align: center;
}
@media only screen and (max-width: 767px) {
  .header__cartcount {
    top: -13px;
    left: 8px;
    width: 22px;
    height: 22px;
    line-height: 23px;
    font-size: 11px;
  }
}
.header__menu {
  margin-right: 0;
}
@media only screen and (max-width: 1120px) {
  .header__menu {
    display: none;
    position: absolute;
    top: calc(100% + 19px);
    left: 0;
    background-color: #fff;
    margin: 0;
    width: 100%;
    z-index: 99;
    box-shadow: 0 10px 10px rgba(0, 0, 0, 0.05);
  }
}
.header__menu .menu {
  margin-bottom: 0;
  padding: 0;
  margin-left: auto;
  display: flex;
  flex-wrap: wrap;
}
.header__menu .menu li {
  list-style: none;
  margin: 0;
}
.header__menu .menu li a {
  display: inline-block;
  text-decoration: none;
  position: relative;
  font-family: "Museo-700" !important;
  font-size: 18px;
  color: #6D6E70;
  line-height: 1.5;
}
.header__menu .menu li a:hover {
  color: #7BBC43;
}
@media only screen and (max-width: 1120px) {
  .header__menu .menu li a {
    width: 100% !important;
    display: block;
    padding: 8px 15px;
  }
}
@media only screen and (max-width: 767px) {
  .header__menu .menu li a {
    font-size: 16px;
  }
}
.header__menu .menu li.active a, .header__menu .menu li.current-menu-item a {
  color: #7BBC43;
}
.header__menu .menu > li {
  position: relative;
}
@media only screen and (max-width: 1120px) {
  .header__menu .menu > li {
    width: 100%;
  }
}
.header__menu .menu > li + li {
  margin-left: 38px;
}
@media only screen and (max-width: 1400px) {
  .header__menu .menu > li + li {
    margin-left: 26px;
  }
}
@media only screen and (max-width: 1120px) {
  .header__menu .menu > li + li {
    margin-left: 0;
    border-top: 1px dashed #ccc;
  }
}
.header__menu .menu > li > a {
  padding-top: 7px;
  padding-bottom: 7px;
}
.header__menu .menu > li > ul {
  position: absolute;
  top: 100%;
  left: 0;
  display: none;
  background: #fff;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.07);
  width: 240px;
  padding: 10px 0;
  border-radius: 3px;
  z-index: 99;
}
.header__menu .menu > li > ul a {
  font-size: 14px;
  font-family: "Museo-300" !important;
  display: block;
  padding: 5px 15px;
}
@media only screen and (max-width: 1120px) {
  .header__menu .menu > li > ul {
    position: static;
    width: 100%;
    box-shadow: none;
    padding: 0 0 10px;
  }
  .header__menu .menu > li > ul a::before {
    content: "-";
    margin-right: 5px;
  }
}
@media only screen and (min-width: 1121px) {
  .header__menu .menu > li:hover ul {
    display: block;
  }
}
.header__menu .menu > li.menu-item-has-children > a {
  padding-right: 20px;
}
.header__menu .menu > li.menu-item-has-children > a::after {
  content: "";
  width: 12px;
  height: 12px;
  background-image: url(https://metjbxcucs-flywheel.netdna-ssl.com/wp-content/uploads/2020/03/caret-down.svg);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  display: inline-block;
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  transition: all ease 0.3s;
}
@media only screen and (max-width: 1120px) {
  .header__menu .menu > li.menu-item-has-children > a::after {
    right: 15px;
  }
}
.header__menu .menu > li.menu-item-has-children > a.header__submenuopen::after {
  transform: translateY(-50%) rotate(-180deg);
}
@media only screen and (max-width: 1400px) {
  .header__cta {
    width: 21px;
  }
}
@media only screen and (max-width: 767px) {
  .header__cta {
    margin-left: 16px !important;
  }
}
.header__cta a {
  display: inline-block;
  background: #7BBC43;
  color: #fff;
  padding: 8px 23px;
  font-size: 18px;
  font-family: "Museo-700" !important;
  text-transform: capitalize;
  text-decoration: none;
}
.header__cta a:hover, .header__cta a:focus {
  background: #6D6E70;
  color: #fff;
  text-decoration: none;
}
@media only screen and (max-width: 767px) {
  .header__cta a {
    font-size: 11px;
    padding: 6px 10px;
  }
}
.header__toggler {
  position: absolute;
  right: 0;
  display: none;
  cursor: pointer;
  top: 50%;
  transform: translateY(-50%);
}
.header__toggler i {
  color: #484848;
  font-size: 24px;
}
@media only screen and (max-width: 767px) {
  .header__toggler i {
    font-size: 21px;
  }
}
.header__toggler:hover i {
  color: #69BE28;
}
@media only screen and (max-width: 1120px) {
  .header__toggler {
    display: block;
  }
}
.header__search {
  position: relative;
}

.f-flexrow {
  margin: 0 -15px;
  display: flex;
  flex-wrap: wrap;
}
.f-flexrow > * {
  padding: 0 15px;
}

::ng-deep.sitefooter {
  background-color: #6D6E70;
  padding: 80px 0 50px;
  font-family: "Museo-300" !important;
}
::ng-deep.sitefooter__toplogo {
  position: relative;
  padding-bottom: 30px;
  margin-bottom: 30px;
}
::ng-deep.sitefooter__toplogo::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 2px;
  background: #f7f7f7;
}
::ng-deep.sitefooter__toplogo a img {
  width: 188px;
}
::ng-deep.sitefooter__inner {
  margin: 0 -15px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.sitefooter__left {
  width: 66%;
}
@media screen and (max-width: 991px) {
  ::ng-deep.sitefooter__left {
    width: 100%;
  }
}
::ng-deep.sitefooter__leftcol {
  width: 50%;
  margin-bottom: 40px;
}
@media screen and (max-width: 580px) {
  ::ng-deep.sitefooter__leftcol {
    width: 100%;
  }
}
::ng-deep.sitefooter__leftcell > div + div {
  margin-top: 40px;
}
::ng-deep.sitefooter__leftcell > div + div.status-site {
  margin-top: 9px;
}
::ng-deep.sitefooter__leftcell > div + div.status-site h6 {
  font-family: "Museo-300" !important;
  font-size: 17px;
  margin-top: 0;
}
::ng-deep.sitefooter__leftcell > div + div.status-site .up-status a {
  color: #7BBC43;
}
::ng-deep.sitefooter__leftcell > div + div.status-site .up-status a:hover {
  text-decoration: none;
  border-bottom: 0;
}
::ng-deep.sitefooter__leftcell ul li + li {
  margin-top: 10px;
}
::ng-deep.sitefooter__leftcell a {
  text-decoration: none;
  display: inline;
  border-bottom: 1px solid transparent;
}
::ng-deep.sitefooter__leftcell a:hover {
  opacity: 1;
  border-bottom-color: #fff;
}
::ng-deep.sitefooter__right {
  width: 33%;
}
@media screen and (max-width: 991px) {
  ::ng-deep.sitefooter__right {
    width: 100%;
  }
}
::ng-deep.sitefooter__right > * + * {
  margin-top: 30px;
}
::ng-deep.sitefooter h6 {
  color: #fff !important;
  font-size: 20px;
  text-transform: none;
  margin: 0 0 15px;
  font-family: "Museo-700" !important;
}
::ng-deep.sitefooter h6 span {
  color: #69BE28;
}
::ng-deep.sitefooter ul {
  padding: 0;
  margin: 0;
}
::ng-deep.sitefooter li {
  line-height: 1.1;
  list-style: none;
  margin-bottom: 0;
}
::ng-deep.sitefooter a {
  line-height: 1.2;
  color: #fff;
  font-size: 16px;
}
::ng-deep.sitefooter a:hover {
  opacity: 0.8;
}
::ng-deep.sitefooter__newsletter h6 {
  margin-bottom: 2px;
}
::ng-deep.sitefooter__newsletter p {
  color: #fff;
  font-size: 16px;
  margin-bottom: 10px;
  line-height: 1.4;
}
::ng-deep.sitefooter__newsletter p a {
  text-decoration: underline;
}
::ng-deep.sitefooter__newsletter p a:hover {
  text-decoration: none;
  color: #fff;
}
::ng-deep.sitefooter__social ul {
  padding-top: 4px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.sitefooter__social ul li:not(:last-child) {
  margin-right: 15px;
}
::ng-deep.sitefooter__social ul li a {
  display: inline-block;
  width: 40px;
  height: 40px;
  background: #fff;
  position: relative;
}
::ng-deep.sitefooter__social ul li a img {
  width: 21px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.sitefooterbottom {
  background: #fff;
  padding: 30px 0;
}
::ng-deep.sitefooterbottom__col {
  width: 33%;
}
::ng-deep.sitefooterbottom__cell p,
::ng-deep.sitefooterbottom__cell a {
  margin: 0;
  font-size: 16px;
  color: #6D6E70;
}
::ng-deep.sitefooterbottom__cell a {
  text-decoration: underline;
}
::ng-deep.sitefooterbottom__cell a:hover {
  opacity: 0.8;
  text-decoration: none;
  color: #6D6E70;
}
::ng-deep.sitefooter__hbsptform .hbsptform .hs-form-field {
  width: 100% !important;
  padding-right: 0 !important;
  margin-bottom: 12px;
}
::ng-deep.sitefooter__hbsptform span.hs-form-required {
  display: none !important;
}
::ng-deep.sitefooter__hbsptform .hs_email {
  width: 100% !important;
  padding-right: 0 !important;
  margin-bottom: 12px;
}
::ng-deep.sitefooter__hbsptform .hs_email label {
  display: none;
}
::ng-deep.sitefooter__hbsptform .submitted-message {
  color: #fff !important;
  background: #5cb85c;
  padding: 15px !important;
  text-align: center;
}
::ng-deep.sitefooter__hbsptform input {
  height: 50px;
  padding: 10px 15px !important;
  font-size: 16px !important;
  width: 100% !important;
  max-width: 100% !important;
  color: #464a4c !important;
  box-shadow: none !important;
}
::ng-deep.sitefooter__hbsptform input:not([type=checkbox]):not([type=radio]) {
  appearance: none;
}
::ng-deep.sitefooter__hbsptform input[type=email] {
  border: 1px solid #ccc !important;
}
::ng-deep.sitefooter__hbsptform input[type=submit] {
  padding: 0 !important;
  text-transform: uppercase;
  font-family: "Museo-700" !important;
  background-color: #7BBC43 !important;
  margin: 0 !important;
  width: 100% !important;
  max-width: 200px !important;
  color: #fff !important;
  border: 0;
  transition: all 0.2s ease-in-out;
}
::ng-deep.sitefooter__hbsptform input[type=submit]:hover {
  background-color: #000 !important;
}
::ng-deep.sitefooter__hbsptform .legal-consent-container {
  text-align: left;
}
::ng-deep.sitefooter__hbsptform .legal-consent-container .hs-richtext {
  margin-bottom: 11px;
}
::ng-deep.sitefooter__hbsptform .legal-consent-container .hs-richtext p {
  font-size: 12px;
}
::ng-deep.sitefooter__hbsptform .legal-consent-container label {
  display: block !important;
  position: relative;
  padding-left: 20px;
  margin-bottom: 0;
}
::ng-deep.sitefooter__hbsptform .legal-consent-container label input {
  margin-top: 0;
  position: absolute;
  top: 3px;
  left: 0;
  width: auto !important;
  height: auto !important;
}
::ng-deep.sitefooter__hbsptform .legal-consent-container label span {
  margin: 0;
  display: block;
}
::ng-deep.sitefooter__hbsptform .legal-consent-container label p {
  font-size: 12px;
}
::ng-deep.sitefooter__hbsptform .hs_submit {
  width: 100%;
}
::ng-deep.sitefooter__hbsptform .hs-error-msgs.inputs-list label {
  color: #fff;
  font-size: 11px;
  font-family: "Museo-300" !important;
  margin: 4px 0 0;
}

.products-grid {
  overflow: hidden;
}

* {
  box-sizing: border-box;
}

img {
  max-width: 100%;
  height: auto;
}

body {
  font-family: "Museo";
}

/*header*/
@media screen and (max-width: 1080px) {
  .mobile-trigger {
    display: inline-block !important;
    cursor: pointer;
    position: absolute;
    top: 40px;
    right: 20px;
    width: 35px;
    height: 25px;
    z-index: 1;
  }
  .mobile-trigger .line {
    display: block;
    background: #fff;
    width: 35px;
    height: 3px;
    position: absolute;
    left: 0;
    transition: all 0.4s;
    -webkit-transition: all 0.4s;
    -moz-transition: all 0.4s;
  }
  .mobile-trigger .line.line-1 {
    top: 0;
  }
  .mobile-trigger .line.line-2 {
    top: 36%;
  }
  .mobile-trigger .line.line-3 {
    top: 71%;
  }
  .mobile-trigger .line {
    background: #6d6e70 !important;
  }
  .mobile-trigger.active-re .line-1 {
    transform: translateY(11px) translateX(0) rotate(45deg);
    -webkit-transform: translateY(11px) translateX(0) rotate(45deg);
    -moz-transform: translateY(11px) translateX(0) rotate(45deg);
    background-color: #fff;
  }
  .mobile-trigger.active-re .line-2 {
    opacity: 0;
  }
  .mobile-trigger.active-re .line-3 {
    transform: translateY(-7px) translateX(0) rotate(-45deg);
    -webkit-transform: translateY(-7px) translateX(0) rotate(-45deg);
    -moz-transform: translateY(-7px) translateX(0) rotate(-45deg);
    background-color: #fff;
  }
}
@media screen and (max-width: 1440px) {
  .frsight-hdr-top .container {
    max-width: 1240px;
    width: 100%;
  }
}
.bm-nav-fixed1 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  right: 0;
  margin: 0 auto;
  transition: 0.5s ease all;
  z-index: 998;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.frsight-hdr-top.bm-nav-fixed1.sticky {
  position: fixed;
  box-shadow: 0px 3px 12px -5px rgba(109, 110, 112, 0.75);
  -webkit-box-shadow: 0px 3px 12px -5px rgba(109, 110, 112, 0.75);
  -moz-box-shadow: 0px 3px 12px -5px rgba(109, 110, 112, 0.75);
}

.bm-nav-sticky {
  position: sticky !important;
  top: 0;
  left: 0;
  width: 100%;
  right: 0;
  margin: 0 auto;
  transition: 0.5s ease all;
  z-index: 998;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.frsight-hdr {
  background-color: #eee;
}

.bm-nav-fixed1.sticky .frsight-hdr {
  background-color: #fff;
  border-top: 5px solid #6d6e70;
}

.container {
  max-width: 1570px;
  margin: 0 auto;
  padding: 0 20px;
}

.frsight-hdr-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
  justify-content: space-between;
}

/*menu*/
.bm-menu-mixed ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.bm-menu-mixed ul li {
  padding: 0;
}

.bm-menu-mixed ul.menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-end;
}

.bm-menu-mixed ul.menu > li {
  margin: 0px 16.5px;
  position: relative;
  padding-bottom: 52px;
  padding-top: 52px;
  line-height: 1.4;
}

.bm-menu-mixed ul.menu > li:first-child {
  margin-left: 0;
}

.bm-menu-mixed ul.menu > li:last-child {
  margin-right: 0;
}

.bm-menu-mixed ul.menu > li::after {
  position: absolute;
  content: "";
  width: auto;
  height: 4px;
  bottom: -1px;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: #7bbd43;
  opacity: 0;
  visibility: hidden;
  transition: 0.5s ease all;
}

.bm-menu-mixed ul.menu > li.active::after,
.bm-menu-mixed ul.menu > li:hover::after {
  opacity: 1;
  visibility: visible;
}

.bm-menu-mixed ul.menu > li > ul {
  display: none;
  position: absolute;
  left: 0;
  width: 100%;
  top: 100%;
  border: 1px solid #fff;
  flex-wrap: wrap;
  align-items: flex-start;
  background-color: #696969;
  z-index: 1;
}

.bm-menu-mixed ul.menu > li.hs-menu-item:hover > ul.hs-menu-children-wrapper {
  display: block;
  min-width: 206px;
}

.bm-menu-mixed ul.menu > li:hover > ul.hs-menu-children-wrapper.menu-col-2 {
  min-width: 460px;
}

.bm-menu-mixed ul.menu > li.hs-menu-item.active > ul.menu-col-2,
.bm-menu-mixed ul.menu > li.hs-menu-item:hover > ul.menu-col-2 {
  display: flex;
}

.bm-menu-mixed ul.menu > li.hs-menu-item > ul.menu-col-2 > li:first-child {
  border-right: 1px solid #fff;
  width: 36.5%;
}

.bm-menu-mixed ul.menu > li.hs-menu-item > ul.menu-col-2 > li:last-child {
  width: 63.5%;
}

.bm-menu-mixed ul.menu > li.hs-menu-item > a {
  color: #3d3d3d;
  text-decoration: none;
  font-size: 18px;
  font-weight: 700;
  position: relative;
}

.bm-menu-mixed ul.menu li:hover > a {
  color: #7bbd43;
}

.bm-menu-mixed ul.menu > li.hs-menu-item.hs-item-has-children > a:after {
  content: "\\f107";
  position: absolute;
  bottom: -30px;
  left: 0;
  right: 0;
  margin: 0 auto;
  font-family: fontawesome;
  font-size: 18px;
  color: #343435;
  text-align: center;
}

.bm-menu-mixed ul.menu > li.hs-menu-item.hs-item-has-children.active > a:after,
.bm-menu-mixed ul.menu > li.hs-menu-item.hs-item-has-children:hover > a:after {
  color: #7bbd43 !important;
}

.bm-menu-mixed ul.menu > li.hs-menu-item > ul > li > a {
  padding: 5px 15px;
  border-bottom: 1px solid #fff;
  display: block;
  text-decoration: none;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
}

.bm-menu-mixed ul.menu > li.hs-menu-item > ul > li > ul > li {
  padding: 5px 15px;
  text-align: left;
}

.bm-menu-mixed ul.menu > li.hs-menu-item > ul li a {
  text-decoration: none;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
}

.bm-menu-mixed ul.menu > li.hs-menu-item > ul li:hover > a {
  color: #7bbd43;
}

@media screen and (max-width: 1080px) {
  .bm-menu-mixed ul.menu > li > ul {
    position: relative;
  }
  .bm-menu-mixed ul.menu > li > ul > li.hs-item-has-children > .child-trigger {
    border-color: #fff;
  }
  .bm-menu-mixed ul.menu > li > ul > li.hs-item-has-children > .child-trigger i,
  .bm-menu-mixed ul.menu > li > ul > li.hs-item-has-children > .child-trigger i::after {
    background-color: #fff;
  }
  .bm-menu-mixed ul.menu > li > ul > li.hs-item-has-children > ul {
    display: none;
  }
  .bm-menu-mixed ul.menu > li.hs-menu-item > ul > li > a {
    padding: 12px 15px !important;
  }
  .bm-menu-mixed ul.menu > li > ul > li.hs-item-has-children {
    position: relative;
  }
}
/*End menu*/
.bm-menu-mixed {
  padding: 0px 20px;
}

.frsight-hdr-right {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.frsight-hdr-right-box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.frsight-hdr-right-box.pos-abs {
  bottom: -4px;
}
@media screen and (max-width: 1080px) {
  .frsight-hdr-right-box {
    padding-right: 40px;
  }
}

.frsight-hdr-right-box .frsight-user-icon {
  margin-right: 7px;
}

.frsight-hdr-right-box svg {
  width: 20px;
  fill: #6d6e70;
}

.frsight-hdr-right-box.fr-left-space1 {
  margin-left: 33px;
}

.frsight-hdr-cta a {
  background-color: #7bbd43;
  border: 1px solid #7bbd43;
  border-radius: 2px;
  color: #fff;
  text-decoration: none;
  padding: 15px 20px;
  font-size: 20px;
  line-height: normal;
  font-weight: 700;
  letter-spacing: 1px;
  display: inline-block;
  position: relative;
  font-family: Museo;
}

.frsight-hdr-right-box p {
  font-size: 17px;
  font-weight: 700;
  margin: 0px;
  color: #454343;
}

.frsight-login a {
  text-decoration: none;
}

.frsight-hdr-right-box.fr-left-space1 {
  margin-left: 33px;
}

.frsight-hdr-cta {
  margin-left: 25px;
}

.bm-nav-fixed1.sticky .bm-menu-mixed .hs-menu-wrapper > ul > li {
  padding-bottom: 30px;
}

.bm-logo-img {
  width: 335px;
}

.bm-menu-mixed li.hs-menu-item.hs-menu-depth-1 > a,
.frsight-hdr-right-box p {
  font-size: 16px;
}

.bm-menu-mixed ul.menu > li.hs-menu-item > a {
  font-size: 18px;
}

.bm-menu-mixed ul.menu > li.hs-menu-item:nth-child(2) > a {
  color: #7bbd43;
}

.bm-menu-mixed ul.menu > li.hs-menu-item > ul li a {
  font-size: 14px;
}

.frsight-hdr-cta a {
  padding: 10px 20px;
  font-size: 12px;
  line-height: normal;
  font-weight: 700;
  letter-spacing: 1px;
  display: inline-block;
  position: relative;
  font-family: Museo;
}

@media (max-width: 1850px) {
  .bm-logo-img {
    width: 260px;
  }
}
@media (max-width: 1440px) {
  .bm-menu-mixed ul.menu > li {
    margin: 0 8px;
  }
}
@media screen and (max-width: 1400px) {
  .frsight-hdr-right-box p {
    font-size: 16px;
  }
  .bm-menu-mixed ul.menu > li.hs-menu-item > a {
    font-size: 16px;
  }
}
@media screen and (max-width: 1300px) {
  .frsight-hdr-right-box p {
    font-size: 14px;
  }
  .bm-logo-img {
    width: 230px;
  }
  .bm-menu-mixed ul.menu > li.hs-menu-item > a {
    font-size: 14px;
  }
}
@media screen and (max-width: 1200px) {
  .bm-logo-img {
    max-width: 190px;
    width: 100%;
    padding: 32px 0;
  }
  .frsight-hdr-right {
    max-width: 378px;
  }
  .bm-menu-mixed ul.menu > li.hs-menu-item > a {
    font-size: 16px;
  }
  .bm-menu-mixed ul.menu > li {
    margin: 0px 6px;
  }
  .frsight-hdr-right-box.fr-left-space1,
  .frsight-hdr-cta {
    margin-left: 12px;
  }
  .bm-menu-mixed {
    width: calc(100% - 568px);
    padding: 0px 15px;
  }
  .frsight-hdr-inner {
    min-height: 100px;
  }
  .bm-menu-mixed ul.menu > li {
    padding-bottom: 37px;
    padding-top: 37px;
  }
  .bm-logo-img {
    width: 180px;
  }
  .bm-menu-mixed ul.menu > li.hs-menu-item > a,
  .frsight-hdr-right-box p {
    font-size: 13px;
  }
}
@media screen and (min-width: 1081px) {
  .frsight-hdr-right.hide-desk {
    display: none;
  }
}
@media screen and (max-width: 1080px) {
  .frsight-hdr-right {
    display: none;
  }
  .bm-menu__inner {
    display: none;
  }
  .bm-menu__inner {
    padding: 15px 20px;
    position: absolute;
    top: 100%;
    left: 0;
    margin: 0;
    background-image: none;
    background-color: #fff;
    border: 0;
    border-radius: 0;
    box-shadow: none;
    max-width: none;
    width: 100%;
    height: auto;
    z-index: 9;
    border-top: 1px solid #000;
    box-shadow: #ccc 2px 5px 10px -2px;
  }
  .child-trigger {
    width: 30px !important;
    min-width: 30px !important;
    height: 21px !important;
    display: block !important;
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 0;
    padding: 0 !important;
    /*border-left: 1px dotted rgba(255,255,255,.20);*/
    border-left: 2px dotted #6d6e70;
  }
  .child-trigger i {
    position: relative;
    top: 50%;
    margin: 0 auto !important;
  }
  .child-trigger i,
  .child-trigger i:after {
    width: 10px;
    height: 2px;
    background-color: #6d6e70;
    display: block;
  }
  .bm-menu-mixed ul.menu > li:first-child {
    border-top: 0px;
  }
  .bm-menu-mixed ul.menu > li.hs-menu-item > a {
    color: #6d6e70;
  }
  .bm-menu-mixed ul.menu > li {
    width: 100%;
    padding: 12px 0 20px;
    margin: 0;
    border-top: 1px dashed #ccc;
  }
  .child-trigger.child-open i:after {
    transform: rotate(-180deg);
  }
  .child-trigger i::after {
    content: "";
    transform: rotate(-90deg);
  }
  .bm-menu-mixed ul.menu > li.hs-menu-item.hs-item-has-children > a:after,
  .bm-menu-mixed ul.menu > li::after {
    display: none;
  }
  .bm-menu-mixed ul.menu > li.hs-menu-item > ul.menu-col-2 > li:last-child,
  .bm-menu-mixed ul.menu > li.hs-menu-item > ul.menu-col-2 > li:first-child {
    width: 100%;
  }
}
/*End header*/
/* start footer */
.frsight-footer-bg {
  background-repeat: no-repeat;
  background-color: rgb(109, 110, 112);
  background-position: 108% 132%;
}

.frsight-footer-bg .frsight-footertop {
  border-bottom: 2px solid #7bbd43;
  padding-bottom: 60px;
}

.dis-flex {
  display: flex;
  flex-wrap: wrap;
}

.frsight-footer-bg .frsight-footertop-box:first-child {
  padding-left: 0;
}

.frsight-footer-bg .frsight-footertop-box {
  width: 33.33%;
  padding: 0px 20px;
}

.frsight-footer-bg .frsight-footer-box-hdr h6 {
  margin-bottom: 25px !important;
}

.frsight-footer-bg * {
  color: #fff;
}

.frsight-footer-bg p,
.frsight-footer-bg ul li,
.frsight-footer-bg ul li a {
  font-weight: 300;
  font-size: 19px;
  font-family: "Open Sans", sans-serif;
}

.frsight-footer-bg .frsight-footertop-right {
  width: 40%;
}

.frsight-footer-bg form {
  display: flex;
  flex-wrap: wrap;
}

.frsight-footer-bg .hs_email.hs-email.hs-fieldtype-text.field.hs-form-field {
  width: 70%;
  margin-bottom: 0;
}

.hs-form-field {
  margin-bottom: 24px;
}

.frsight-footer-bg form .hs_email.hs-email > label {
  display: none;
}

.frsight-footer-bg form input[type=email] {
  background-color: #fff;
  box-shadow: none;
  border: 0;
  color: #51668a;
  font-size: 18px;
  padding: 0.7rem;
  width: 100%;
  border-radius: 3px;
  display: inline-block;
}

.frsight-footer-bg form .inputs-list {
  list-style: none;
  padding-left: 0;
}

.hs-form-booleancheckbox span {
  padding-left: 28px;
}

.hs-form-booleancheckbox span,
.hs-form-booleancheckbox span a {
  font-size: 15px !important;
}

.frsight-footer-bg form .hs-form-required {
  display: none !important;
}

.frsight-footer-bg .hs-form-field {
  margin-bottom: 24px;
}

.frsight-footer-bg form .inputs-list > li {
  display: block;
  margin: 0.7rem 0;
}

.frsight-footer-bg ul li label input[type=checkbox],
.frsight-footer-bg ul li label input[type=radio] {
  opacity: 0;
  display: none !important;
}

.frsight-footer-bg ul li label input[type=checkbox],
.frsight-footer-bg .input ul li label span,
.frsight-footer-bg ul li label input[type=radio] {
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
  position: relative;
}

.frsight-footer-form ul li label input[type=checkbox] + span:before,
.frsight-footer-form ul li label input[type=radio] + span:before {
  top: 4px;
}

.frsight-footer-form ul li label input[type=checkbox]:checked + span:before,
.frsight-footer-form ul li label input[type=radio]:checked + span:before {
  content: "\\f00c";
}

.frsight-footer-form ul li label input[type=checkbox] + span:before,
.frsight-footer-form ul li label input[type=radio] + span:before {
  color: #5bba7e;
  content: " ";
  background: #e5e5e5;
  border: 2px solid #ddd;
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  padding: 2px;
  margin-right: 10px;
  text-align: center;
  font-family: FontAwesome;
  line-height: 14px;
  box-shadow: none;
  position: absolute;
  left: 0;
  top: 3px;
  font-size: 12px;
  box-sizing: border-box;
}

.frsight-footer-bg label.hs-error-msg {
  font-size: 14px;
}

.frsight-footer-bg label {
  font-weight: 400;
}

.frsight-footer-bg form input[type=submit] {
  background-color: #7bbd43;
  width: 100%;
  font-size: 19px;
  box-shadow: none;
  border: unset;
  height: 55px;
  border-radius: 3px;
  border-top-left-radius: unset;
  border-bottom-left-radius: unset;
  border: 2px solid #7bbd43;
}

.frsight-footer-bg-left {
  width: 30%;
}

.frsight-footer-bg .frsight-footer-logo {
  max-width: 325px;
}

.frsight-footer-bg .frsight-footer-logo {
  margin-bottom: 20px;
}

.frsight-footer-bg .frsight-footer-social {
  margin-top: 25px;
}

.frsight-footer-bg .frsight-footer-social ul {
  padding-left: 0;
  display: inline-block;
}

.frsight-footer-bg .frsight-footer-social ul li {
  list-style: none;
  display: inline-block;
  color: #7bbd43 !important;
  padding-right: 10px;
}

.frsight-footer-bg .frsight-footer-social ul li a {
  font-size: 22px;
  color: #7bbd43 !important;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 55px;
  height: 55px;
  border: 2px solid #fff;
  border-radius: 22px;
}

.frsight-footer-social .fa {
  color: #7bbd43;
}

.frsight-footer-bg-right.dis-flex {
  width: 70%;
  padding-left: 120px;
}

.frsight-footer-bg .frsight-footer-box:first-child {
  padding-left: 0;
}

.frsight-footer-box {
  width: 25%;
  padding: 0px 20px;
}

.frsight-footer-bg .hs-menu-wrapper ul {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding-left: 0;
}

.frsight-footer-bg .frsight-footer-box-menu ul li {
  margin-bottom: 10px;
  width: 100%;
}

.frsight-footer-bg h6 {
  font-size: 25px;
  font-weight: bold;
  font-weight: 900;
}

.frsight-footer-bg .hs_submit.hs-submit {
  width: 100%;
  max-width: 144px;
}

.frsight-footer-bg .hs-prviacy_policy {
  width: 100%;
}

@media screen and (max-width: 1850px) {
  .frsight-footer-bg h6 {
    font-size: 20px;
  }
}
@media screen and (max-width: 1650px) {
  .frsight-footer-bg form input[type=submit],
  .frsight-footer-bg form input[type=email] {
    height: 48px !important;
  }
  .frsight-footer-bg h6 {
    font-size: 19px;
  }
}
.frsight-footer-bg .frsight-footertop-left {
  padding-right: 50px;
  width: 60%;
}

.frsight-footer-bg-inner.dis-flex {
  padding-top: 85px;
}

.frsight-footer-bg {
  padding: 60px 0px 185px 0px;
}

@media screen and (max-width: 1440px) {
  .frsight-footertop .container {
    max-width: 1240px !important;
  }
  .frsight-footer-bg p,
  .frsight-footer-bg ul li,
  .frsight-footer-bg ul li a {
    font-weight: 300;
    font-size: 16px;
  }
  .frsight-footer-bg-right.dis-flex {
    padding-left: 50px;
  }
  .frsight-footer-bg .container {
    max-width: 1240px;
    width: 100%;
  }
  .frsight-footer-bg h6 {
    font-size: 18px;
  }
}
@media screen and (max-width: 1024px) {
  .frsight-footer-bg .frsight-footertop-left {
    width: 100%;
    padding-right: 0;
    padding-bottom: 20px;
  }
  .frsight-footer-bg .frsight-footertop-right {
    width: 100%;
  }
  .frsight-footer-bg-left {
    width: 100%;
  }
  .frsight-footer-bg-right.dis-flex {
    padding-left: 0;
    padding-top: 20px;
    width: 100%;
  }
}
@media screen and (max-width: 991px) {
  .frsight-footer-bg-inner.dis-flex {
    padding-top: 60px;
  }
  .frsight-footer-bg {
    padding: 60px 0px 80px 0px;
  }
  .frsight-footer-bg h6 {
    font-size: 16px;
  }
}
@media screen and (max-width: 767px) {
  .frsight-footer-bg .frsight-footertop-box {
    width: 100%;
    padding: 0;
    padding-bottom: 20px;
  }
  .frsight-footer-box {
    width: 100%;
    padding: 0;
    padding-bottom: 20px;
  }
  .frsight-footer-bg p,
  .frsight-footer-bg ul li,
  .frsight-footer-bg ul li a {
    font-size: 18px;
  }
  .frsight-footer-bg {
    padding: 60px 0px 60px 0px;
  }
}
@media screen and (max-width: 480px) {
  .frsight-footer-bg .hs_email.hs-email.hs-fieldtype-text.field.hs-form-field {
    width: 100%;
    margin-bottom: 15px;
  }
}
/* end footer */
.cntnr-bg {
  max-width: 2400px;
  margin: 0 auto;
  padding: 0 30px;
  width: 100%;
}
@media screen and (max-width: 1240px) {
  .cntnr-bg {
    padding: 0 20px;
  }
}

.frsight-hdr * {
  font-family: Museo;
}
.frsight-hdr * .frsight-demo-font {
  font-family: "Museo-regular";
}

.cont {
  padding-inline: 15px;
  margin-inline: auto;
}
@media screen and (min-width: 768px) {
  .cont {
    width: 750px;
  }
}
@media screen and (min-width: 992px) {
  .cont {
    width: 970px;
  }
}
@media screen and (min-width: 1400px) {
  .cont {
    width: 1350px;
  }
}
@media screen and (min-width: 1600px) {
  .cont {
    width: 1570px;
    padding-inline: 20px;
  }
}
@media screen and (max-width: 1850px) {
  .cont {
    width: 1300px;
    padding-inline: 15px;
  }
}
@media screen and (max-width: 1440px) {
  .cont {
    width: 1240px;
  }
}
@media screen and (max-width: 1200px) {
  .cont {
    width: 100%;
  }
}

.frsight-user-icon .crt-qty {
  top: -16px;
  left: 50%;
  transform: translateX(-50%);
}

.cmn__hdr-new {
  position: relative;
}

.cmn__hdr-new .frsight-hdr-inner {
  margin-inline: auto;
  width: 1300px;
  padding-inline: 20px;
}
@media screen and (min-width: 1849px) {
  .cmn__hdr-new .frsight-hdr-inner {
    width: 1570px;
    padding-inline: 20px;
  }
}
@media screen and (max-width: 1199px) {
  .cmn__hdr-new .frsight-hdr-inner {
    width: 100%;
    padding-inline: 30px;
  }
}

@media screen and (min-width: 1849px) {
  .cmn__hdr-new .frsight-hdr-inner.frsight-hdr-inner-indv {
    width: 1300px;
    padding-inline: 20px;
  }
}
@media screen and (max-width: 1299px) {
  .cmn__hdr-new .frsight-hdr-inner.frsight-hdr-inner-indv {
    padding-inline: 30px;
  }
}
@media screen and (max-width: 767px) {
  .cmn__hdr-new .frsight-hdr-inner.frsight-hdr-inner-indv {
    padding-inline: 20px;
  }
}
@media screen and (max-width: 1199px) {
  .cmn__hdr-new .frsight-hdr-inner.frsight-hdr-inner-indv {
    width: 100%;
  }
}

.cmn__hdr-new .frsight-hdr {
  background: #fff;
}

.cmn__hdr-new .cntnr-bg {
  padding-inline: 0;
}

.cmn__hdr-new .bm-logo-img {
  width: 234px;
}

.cmn__hdr-new .menu {
  gap: 40px;
}
@media (max-width: 1299px) {
  .cmn__hdr-new .menu {
    gap: 20px;
  }
}

.cmn__hdr-new .custom-menu-primary {
  flex: 1;
}

.cmn__hdr-new .menu > li {
  padding-block: 31px !important;
  margin-inline: 0 !important;
}
@media (max-width: 1080px) {
  .cmn__hdr-new .menu {
    gap: 0;
  }
}

.cmn__hdr-new .menu > li:after {
  display: none;
}

.cmn__hdr-new .menu > li > a {
  display: block;
  font-size: 14px !important;
  font-weight: 400 !important;
  font-family: "Museo-regular" !important;
  color: #666 !important;
  line-height: 18px !important;
  text-decoration: none !important;
  transition: all 0.3s ease 0s;
}

.cmn__hdr-new .menu > li.hs-item-has-children > a {
  padding-right: 21px !important;
}

.cmn__hdr-new .menu > li > a:hover {
  color: #00add0 !important;
}

.cmn__hdr-new .hs-item-has-children > a:after {
  content: "" !important;
  width: 11px;
  height: 6px;
  background-image: url(https://www.foursightonline.com/hubfs/2025/arrow_down.svg);
  background-repeat: no-repeat;
  position: absolute !important;
  top: 50%;
  left: auto !important;
  right: 0 !important;
  bottom: auto !important;
  top: 50%;
  transform: translateY(-50%);
}

.cmn__hdr-new .frsight-hdr-right-box a {
  display: inline-block;
  padding: 0 2px;
  text-align: center;
  color: #666 !important;
  text-decoration: none;
  transition: 0.3s;
  border-bottom: 1px solid transparent;
}
.cmn__hdr-new .frsight-hdr-right-box a.active {
  border-color: #666;
}

.cmn__hdr-new .frsight-hdr-right-box a:hover {
  border-color: #666;
}

.cmn__hdr-new .frsight-hdr-right-box a p {
  font-size: 14px;
  font-weight: 400 !important;
  font-family: "Museo-regular" !important;
  color: #666 !important;
  line-height: 130%;
}

.cmn__hdr-new .frsight-hdr-right-box a:hover p {
  color: #666 !important;
}

.cmn__hdr-new .frsight-hdr-cta {
  margin-left: 40px !important;
}

.cmn__hdr-new .frsight-hdr-cta a {
  display: inline-block;
  font-size: 16px;
  font-weight: 400 !important;
  font-family: "Museo-regular" !important;
  justify-content: center;
  line-height: 26px;
  padding: 6px 24px;
  letter-spacing: 0;
  background-color: #69be28;
  border: 1px solid #69be28;
}

.cmn__hdr-new .frsight-hdr-cta a:hover {
  background-color: #00add0;
  border-color: #00add0;
}

@media (max-width: 1080px) {
  .cmn__hdr-new .frsight-hdr-right {
    display: flex;
  }
}
@media (min-width: 1081px) {
  .cmn__hdr-new .hs-menu-children-wrapper {
    max-width: 300px;
    min-width: 120px !important;
    background-color: var(--clr_white) !important;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.05);
    padding: 0 10px 7px;
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    background: #fff !important;
  }
  .cmn__hdr-new .hs-menu-children-wrapper li:not(:last-child) {
    border-bottom: 1px solid #f1f1f1 !important;
  }
  .cmn__hdr-new.frsight-hdr-top .hs-menu-children-wrapper li a {
    color: var(--clr_gray) !important;
    display: block !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    font-family: "Museo-regular" !important;
    line-height: 18px !important;
    text-decoration: none !important;
    padding: 10px 0 !important;
    transition: 0.3s;
  }
  .cmn__hdr-new.frsight-hdr-top .hs-menu-children-wrapper li a:hover {
    color: #00add0 !important;
  }
  .cmn__hdr-new .bm-logo-img {
    padding-block: 18px;
  }
}
.gap-10 {
  gap: 10px;
}

.cmn__ftr-new {
  background-color: #666;
  padding-block: 30px 26px;
}

.cmn__ftr-new .container {
  max-width: 1370px !important;
  margin-inline: auto;
  width: calc(100% - 48px);
  padding: 0;
}

.cmn__ftr-new .footer__col,
.cmn__ftr-new .footer__list {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.cmn__ftr-new .footer__top {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
@media (max-width: 1080px) {
  .cmn__ftr-new .footer__top {
    gap: 40px;
  }
}

.cmn__ftr-new .footer__col {
  width: 33.33%;
}
@media (max-width: 1080px) {
  .cmn__ftr-new .footer__col {
    width: 100%;
  }
}

.cmn__ftr-new .footer__logo {
  max-width: 327px;
  width: 100%;
}
@media (max-width: 480px) {
  .cmn__ftr-new .footer__logo {
    max-width: 210px;
  }
}

.cmn__ftr-new .footer__logo {
  width: 100%;
}

.cmn__ftr-new .footer__content {
  font-size: 18px;
  font-family: "MuseoSans-300" !important;
  color: #fff;
  line-height: 1.65;
}
@media (max-width: 480px) {
  .cmn__ftr-new .footer__content {
    font-size: 16px;
  }
}

.cmn__ftr-new .footer__col:first-child {
  max-width: 460px;
}
@media (max-width: 1080px) {
  .cmn__ftr-new .footer__col:first-child {
    max-width: none;
  }
}

.cmn__ftr-new .footer__col:nth-child(2) {
  max-width: 288px;
}
@media (max-width: 1080px) {
  .cmn__ftr-new .footer__col:nth-child(2) {
    max-width: none;
  }
}

.footer__col:last-child {
  max-width: 342px;
}
@media (max-width: 1080px) {
  .footer__col:last-child {
    max-width: none;
  }
}

.cmn__ftr-new .footer__menu ul {
  column-count: 2;
  gap: 90px;
  padding: 0;
  margin: 0;
}

.cmn__ftr-new .footer__menu li {
  display: block;
  line-height: 1;
  margin-bottom: 16px;
}

.cmn__ftr-new .footer__menu a {
  color: #fff;
  display: block;
  font-size: 14px;
  font-family: "MuseoSans-300" !important;
  line-height: 18px;
  text-decoration: none;
  white-space: nowrap;
}

.cmn__ftr-new .footer__menu a:hover {
  text-decoration: underline;
}

.cmn__ftr-new .footer__title {
  font-family: "Abel", sans-serif;
  font-size: 24px;
  color: #fff;
  text-align: right;
}
@media (max-width: 1080px) {
  .cmn__ftr-new .footer__title {
    text-align: left;
  }
}
@media (max-width: 480px) {
  .cmn__ftr-new .footer__title {
    font-size: 20px;
  }
}

.cmn__ftr-new .footer__bottom {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
}

.cmn__ftr-new .button_container {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  line-height: 1;
}
.cmn__ftr-new .button_container .button {
  align-items: center;
  background-color: #69be28;
  border: 1px solid #69be28;
  border-radius: 3px;
  color: #fff;
  display: inline-flex;
  flex-wrap: wrap;
  font-family: "Museo-regular";
  font-size: 16px;
  justify-content: center;
  line-height: 26px;
  min-width: 172px;
  padding: 6px 24px;
  text-align: center;
  text-decoration: none;
  transition: 0.3s;
}
.cmn__ftr-new .button_container .button:hover {
  background-color: #00add0;
  border-color: #00add0;
}

.cmn__ftr-new .footer__social {
  display: flex;
  flex-wrap: wrap;
  gap: 19px;
}

.cmn__ftr-new .footer__social a {
  align-items: center;
  background-color: #d9d9d9;
  border-radius: 50%;
  display: flex;
  height: 26px;
  justify-content: center;
  width: 26px;
  transition: 0.3s;
}
.cmn__ftr-new .footer__social a:hover {
  background: #69be28;
}
.cmn__ftr-new .footer__social a svg {
  height: auto;
  width: 11px;
  fill: #666;
}
.cmn__ftr-new .footer__social a:hover svg {
  fill: #fff;
}

.cmn__ftr-new .footer__legal {
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  font-family: "Abel", sans-serif;
  font-size: 14px;
  margin-left: auto;
}
@media (max-width: 767px) {
  .cmn__ftr-new .footer__legal {
    width: 100%;
  }
}

.cmn__ftr-new .footer__legal * {
  line-height: 18px;
  position: relative;
}

.cmn__ftr-new .footer__legal > :not(:last-child) {
  margin-right: 10px;
  padding-right: 10px;
}

.cmn__ftr-new .footer__legal a {
  color: inherit;
  text-decoration: none;
}
.cmn__ftr-new .footer__legal a:hover {
  text-decoration: underline;
}

.cmn__ftr-new .footer__legal > :not(:last-child):after {
  background-color: #fff;
  bottom: 2px;
  content: "";
  position: absolute;
  right: 0;
  top: 2px;
  width: 1px;
}

.cmn__ftr-new .footer__col form {
  display: flex;
}
.cmn__ftr-new .footer__col form .hs-email {
  flex: 1;
  margin: 0;
}
.cmn__ftr-new .footer__col form input:not([type=submit]) {
  width: 100% !important;
  background-color: #fff;
  border-radius: 6px 0 0 6px;
  font-size: 18px;
  font-family: "Abel", sans-serif;
  line-height: 30px;
  padding: 4px 13px;
  border: 1px solid #69be28;
  border-right: 0;
}
.cmn__ftr-new .footer__col form input:placeholder {
  color: #a9a9a9;
  opacity: 1;
}
.cmn__ftr-new .footer__col form input:focus {
  outline: none;
}
.cmn__ftr-new .footer__col form input[type=submit] {
  border-radius: 0 6px 6px 0;
  font-size: 18px;
  line-height: 30px;
  min-width: auto;
  padding: 5px 23px;
  background-color: #69be28;
  border: 0;
  color: #fff;
  font-family: "Museo-regular" !important;
  transition: 0.3s;
}
.cmn__ftr-new .footer__col form input[type=submit]:hover {
  background: #00add0;
  cursor: pointer;
}

.products-grid {
  display: none !important;
}

.product-section {
  padding: 60px 0 56px !important;
}
@media (max-width: 767px) {
  .product-section {
    padding: 40px 0 56px !important;
  }
}
.product-section .container {
  max-width: 1240px;
}
@media (max-width: 480px) {
  .product-section .prd-pic {
    margin-bottom: 30px;
  }
}
.product-section .prd-cnt {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.product-section .prd-cnt .title {
  font-size: 48px;
  font-family: "Museo-regular";
  color: #666;
  line-height: 104.167%;
  margin: 0;
}
@media (max-width: 480px) {
  .product-section .prd-cnt .title {
    font-size: 36px;
  }
}
.product-section .prd-cnt .price {
  font-size: 24px;
  font-family: "Museo-regular";
  line-height: 125%;
  color: #666;
}
.product-section .prd-cnt p {
  font-size: 18px;
  font-weight: 400;
  font-family: "Museo-regular";
  color: #666;
  line-height: 166.667%;
}
.product-section .prd-cnt p a {
  font-family: "Museo-regular";
  color: #666;
  text-decoration: underline;
}
@media (max-width: 480px) {
  .product-section .prd-cnt p {
    font-size: 16px;
  }
}
.product-section .prd-cnt .btn {
  min-width: 214px;
  align-items: center;
  background-color: #69be28;
  border: 1px solid #69be28;
  border-radius: 3px;
  color: #fff;
  display: inline-flex;
  flex-wrap: wrap;
  font-family: "Museo-regular";
  font-size: 16px;
  justify-content: center;
  line-height: 26px;
  min-width: 172px;
  padding: 6px 24px;
  text-align: center;
  text-decoration: none;
  transition: 0.3s;
}
.product-section .prd-cnt .btn:hover {
  background-color: #00add0;
  border-color: #00add0;
}

.book-demo {
  position: relative;
  z-index: 999;
}

.public_footer {
  width: calc(83% - 220px);
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/store/public-store/public-store.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC7HF;;ADgIA;EACE,aAAA;EACA,eAAA;AC7HF;;ADgIA;EACE,sBAAA;AC7HF;;ADgIA;EACE,8BAAA;AC7HF;;ADgIA;EACE,gBAAA;AC7HF;;ADgIA;EACE,gBAAA;AC7HF;;ADgIA;EACE,aAAA;AC7HF;;ADgIA;EACE,gBAAA;AC7HF;;AD2IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ACxIJ;AD0II;;;;;;EACE,gBAAA;ACnIN;ADuIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC1BX;ADuII;EALF;;IAMI,eA/GY;ECpBhB;AACF;ADsIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACnBX;ADsII;EALF;;IAMI,eArHY;ECbhB;AACF;ADqIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACZX;ADqII;EALF;;IAMI,eA3HY;ECNhB;AACF;ADoIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACLX;ADqIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACHX;ADsIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACDX;AD0IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ACxIJ;AD0II;EACE,gBAAA;ACxIN;AD2II;EAXF;IAYI,eAAA;ECxIJ;AACF;AD2IE;;EAEE,UAAA;EACA,SAAA;ACzIJ;AD4IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC1IJ;;AD8IA;EACE,sBAxNQ;AC6EV;;AD8IA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC3IF;AD6IE;EALF;IAMI,cAAA;EC1IF;AACF;AD4IE;EACE,iBA1Ka;ACgCjB;AD6IE;EACE,gBApLa;EAqLb,WAAA;AC3IJ;;ADgJE;EACE,kBAAA;AC7IJ;ADgJE;EACE,iBAAA;AC9IJ;;ADmJE;EACE,aAAA;AChJJ;;ADoJA;EACE,kBAAA;ACjJF;ADmJE;EACE,mBAAA;ACjJJ;ADqJI;EACE,sBAAA;ACnJN;ADuJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACyEnB;ADuJI;EACE,sBAAA;ACrJN;ADwJI;EAVF;IAWI,eApOoB;EC+ExB;AACF;ADwJE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACtJJ;ADwJI;EACE,sBAAA;ACtJN;ADyJI;EACE,WAAA;ACvJN;AD0JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACoMZ;;AD6JA;EACE,mBA1PO;ACgGT;AD4JE;EAHF;IAII,mBAAA;ECzJF;AACF;AD2JE;EACE,mBAAA;ACzJJ;AD4JE;EACE,aArQK;AC2GT;AD4JI;EAHF;IAII,aAAA;ECzJJ;AACF;AD2JI;EACE,aAAA;ACzJN;;AD8JA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC3JF;AD6JE;EACE,eAAA;AC3JJ;AD8JE;EACE,sCAAA;AC5JJ;AD+JE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC7JJ;;AD4KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;ACzKJ;AD2KI;EACE,kBAAA;ACzKN;AD4KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC1KN;;AD+KA;EACE,8BAAA;AC5KF;;AD+KA;EACE,8BAAA;AC5KF;;AD+KA;EACE,+BAAA;AC5KF;;AD+KA;EACE,8BAAA;AC5KF;;AD+KA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC5KF;AD8KE;EACE,2BAAA;EACA,mBAAA;AC5KJ;AD+KE;EACE,yBAzbiB;EA0bjB,WA1aO;AC6PX;ADgLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AC9KJ;ADiLE;EACE,yBAjckB;EAkclB,cArciB;ACsRrB;ADkLE;EACE,yBAvbS;EAwbT,WA1bO;AC0QX;ADkLI;EACE,6BAAA;AChLN;;ADqLA;EACE;IACE,uBAAA;EClLF;EDqLA;IACE,yBAAA;ECnLF;AACF;ADsLA;EACE,8BAAA;ACpLF;;ADuLA;EACE,8BAAA;ACpLF;;ADuLA;EACE,+BAAA;ACpLF;;ADuLA;EACE,8BAAA;ACpLF;;ADuLA;EACE,qBAAA;ACpLF;;ADuLA;EACE,UAAA;ACpLF;ADsLE;EACE,qBAAA;ACpLJ;;ADwLA;EACE,UAAA;ACrLF;;ADyLE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACvLJ;AD0LM;EACE,mBAAA;ACxLR;AD6LE;EACE,2BAAA;AC3LJ;AD8LE;EACE,uBAAA;AC5LJ;AD+LE;EACE,mBAAA;AC7LJ;;ADkME;EACE,mBAAA;AC/LJ;ADkME;EACE,yBAAA;AChMJ;ADmME;EACE,sBAAA;ACjMJ;ADoME;EACE,uBAAA;AClMJ;ADqME;EACE,oBAAA;ACnMJ;;AA/YA;EACE,WAAA;EACA,eAAA;EACA,cAAA;AAkZF;AAhZE;EALF;IAMI,gBAAA;EAmZF;AACF;AAjZE;EATF;IAUI,gBAAA;EAoZF;AACF;AAlZE;EAbF;IAcI,gBAAA;EAqZF;AACF;AAnZE;EAjBF;IAkBI,iBAAA;EAsZF;AACF;;AAnZA;EAGE,aAAA;EAEA,eAAA;AAsZF;;AAjZA;EACE,kBAAA;EACA,8BAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;AAoZF;AAlZE;EAPF;IAQI,qBAAA;EAqZF;AACF;AAnZE;EACE,kBAAA;EAGA,mBAAA;AAqZJ;AAnZI;EANF;IAOI,mBAAA;EAsZJ;AACF;AApZI;EAVF;IAWI,mBAAA;EAuZJ;AACF;AApZE;EACE,qBAAA;AAsZJ;AAnZE;EACE,YAAA;AAqZJ;AAnZI;EACE,eAAA;AAqZN;AAlZI;EAPF;IAQI,YAAA;EAqZJ;AACF;AAnZI;EAXF;IAYI,YAAA;EAsZJ;AACF;AAnZE;EACE,iBAAA;EAGA,mBAAA;AAqZJ;AAnZI;EACE,iBAAA;AAqZN;AAnZM;EAHF;IAII,iBAAA;EAsZN;AACF;AAhZI;EACE,WAAA;AAkZN;AAhZM;EAHF;IAII,WAAA;EAmZN;AACF;AA/YE;EACE,cAAA;EACA,kBAAA;AAiZJ;AA/YI;EACE,kBAAA;EAGA,aAAA;EAEA,eAAA;EAGA,mBAAA;AAiZN;AA9YI;EACE,WAAA;EACA,YAAA;EACA,sHAAA;EACA,kCAAA;EACA,4BAAA;EACA,wBAAA;AAgZN;AA9YM;EACE,aAAA;AAgZR;AA7YM;EAZF;IAaI,WAAA;IACA,YAAA;EAgZN;AACF;AA7YI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;EACA,kBAAA;AA+YN;AA7YM;EAdF;IAeI,UAAA;IACA,SAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;EAgZN;AACF;AA5YE;EACE,eAAA;AA8YJ;AA5YI;EAHF;IAII,aAAA;IACA,kBAAA;IACA,sBAAA;IACA,OAAA;IACA,sBAAA;IACA,SAAA;IACA,WAAA;IACA,WAAA;IACA,2CAAA;EA+YJ;AACF;AA7YI;EACE,gBAAA;EACA,UAAA;EACA,iBAAA;EAGA,aAAA;EAEA,eAAA;AA+YN;AA7YM;EACE,gBAAA;EACA,SAAA;AA+YR;AA7YQ;EACE,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA+YV;AA7YU;EACE,cAAA;AA+YZ;AA5YU;EAbF;IAcI,sBAAA;IACA,cAAA;IACA,iBAAA;EA+YV;AACF;AA7YU;EAnBF;IAoBI,eAAA;EAgZV;AACF;AA3YU;EACE,cAAA;AA6YZ;AAxYM;EACE,kBAAA;AA0YR;AAxYQ;EAHF;IAII,WAAA;EA2YR;AACF;AAzYQ;EACE,iBAAA;AA2YV;AAzYU;EAHF;IAII,iBAAA;EA4YV;AACF;AA1YU;EAPF;IAQI,cAAA;IACA,2BAAA;EA6YV;AACF;AA1YQ;EACE,gBAAA;EACA,mBAAA;AA4YV;AAzYQ;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,gBAAA;EACA,wCAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AA2YV;AAzYU;EACE,eAAA;EACA,mCAAA;EACA,cAAA;EACA,iBAAA;AA2YZ;AAxYU;EAnBF;IAoBI,gBAAA;IACA,WAAA;IACA,gBAAA;IACA,iBAAA;EA2YV;EAxYY;IACE,YAAA;IACA,iBAAA;EA0Yd;AACF;AApYU;EADF;IAEI,cAAA;EAuYV;AACF;AAnYU;EACE,mBAAA;AAqYZ;AAnYY;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,2GAAA;EACA,4BAAA;EACA,kCAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EAGA,2BAAA;EAGA,yBAAA;AAqYd;AAnYc;EAnBF;IAoBI,WAAA;EAsYd;AACF;AAnYY;EAGE,2CAAA;AAqYd;AA5XI;EADF;IAEI,WAAA;EA+XJ;AACF;AA7XI;EALF;IAMI,4BAAA;EAgYJ;AACF;AA9XI;EACE,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,0BAAA;EACA,qBAAA;AAgYN;AA9XM;EAEE,mBAAA;EACA,WAAA;EACA,qBAAA;AA+XR;AA5XM;EAjBF;IAkBI,eAAA;IACA,iBAAA;EA+XN;AACF;AA3XE;EACE,kBAAA;EACA,QAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;EAGA,2BAAA;AA6XJ;AA3XI;EACE,cAAA;EACA,eAAA;AA6XN;AA3XM;EAJF;IAKI,eAAA;EA8XN;AACF;AA3XI;EACE,cAAA;AA6XN;AA1XI;EAvBF;IAwBI,cAAA;EA6XJ;AACF;AA1XE;EACE,kBAAA;AA4XJ;;AAtXA;EACE,eAAA;EAGA,aAAA;EAEA,eAAA;AAyXF;AAvXE;EACE,eAAA;AAyXJ;;AArXA;EACE,yBAAA;EACA,oBAAA;EACA,mCAAA;AAwXF;AAtXE;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;AAwXJ;AAtXI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;AAwXN;AApXM;EACE,YAAA;AAsXR;AAjXE;EACE,eAAA;EAGA,aAAA;EAEA,eAAA;AAmXJ;AAhXE;EACE,UAAA;AAkXJ;AAhXI;EAHF;IAII,WAAA;EAmXJ;AACF;AAjXI;EACE,UAAA;EACA,mBAAA;AAmXN;AAjXM;EAJF;IAKI,WAAA;EAoXN;AACF;AAhXM;EACE,gBAAA;AAkXR;AAhXQ;EACE,eAAA;AAkXV;AAhXU;EACE,mCAAA;EACA,eAAA;EACA,aAAA;AAkXZ;AA9WY;EACE,cAAA;AAgXd;AA9Wc;EACE,qBAAA;EACA,gBAAA;AAgXhB;AAvWU;EACE,gBAAA;AAyWZ;AApWM;EACE,qBAAA;EACA,eAAA;EACA,oCAAA;AAsWR;AApWQ;EACE,UAAA;EACA,yBAAA;AAsWV;AAhWE;EACE,UAAA;AAkWJ;AAhWI;EAHF;IAII,WAAA;EAmWJ;AACF;AAjWI;EACE,gBAAA;AAmWN;AA/VE;EACE,sBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,mCAAA;AAiWJ;AA/VI;EACE,cAAA;AAiWN;AA7VE;EACE,UAAA;EACA,SAAA;AA+VJ;AA5VE;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;AA8VJ;AA3VE;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AA6VJ;AA3VI;EACE,YAAA;AA6VN;AAxVI;EACE,kBAAA;AA0VN;AAvVI;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAyVN;AAvVM;EACE,0BAAA;AAyVR;AAvVQ;EACE,qBAAA;EACA,WAAA;AAyVV;AAnVE;EACE,gBAAA;EAGA,aAAA;EAEA,eAAA;AAqVJ;AAlVM;EACE,kBAAA;AAoVR;AAjVM;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAmVR;AAjVQ;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AAmVV;AA7UE;EACE,gBAAA;EACA,eAAA;AA+UJ;AA7UI;EACE,UAAA;AA+UN;AA1UM;;EAEE,SAAA;EACA,eAAA;EACA,cAAA;AA4UR;AAzUM;EACE,0BAAA;AA2UR;AAzUQ;EACE,YAAA;EACA,qBAAA;EACA,cAAA;AA2UV;AApUI;EACE,sBAAA;EACA,2BAAA;EACA,mBAAA;AAsUN;AAnUI;EACE,wBAAA;AAqUN;AAlUI;EACE,sBAAA;EACA,2BAAA;EACA,mBAAA;AAoUN;AAlUM;EACE,aAAA;AAoUR;AAhUI;EACE,sBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;AAkUN;AA/TI;EACE,YAAA;EACA,6BAAA;EACA,0BAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;EACA,2BAAA;AAiUN;AA/TM;EAGE,gBAAA;AAiUR;AA9TM;EACE,iCAAA;AAgUR;AA7TM;EACE,qBAAA;EACA,yBAAA;EACA,mCAAA;EACA,oCAAA;EACA,oBAAA;EACA,sBAAA;EACA,2BAAA;EACA,sBAAA;EACA,SAAA;EAGA,gCAAA;AA+TR;AA7TQ;EACE,iCAAA;AA+TV;AA1TI;EACE,gBAAA;AA4TN;AA1TM;EACE,mBAAA;AA4TR;AA1TQ;EACE,eAAA;AA4TV;AAxTM;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AA0TR;AAxTQ;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,sBAAA;EACA,uBAAA;AA0TV;AAvTQ;EACE,SAAA;EACA,cAAA;AAyTV;AAtTQ;EACE,eAAA;AAwTV;AAnTI;EACE,WAAA;AAqTN;AAlTI;EACE,WAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;AAoTN;;AA/SA;EACE,gBAAA;AAkTF;;AA1SA;EACE,sBAAA;AA6SF;;AA1SA;EACE,eAAA;EACA,YAAA;AA6SF;;AA1SA;EACE,oBAAA;AA6SF;;AA1SA,SAAA;AACA;EACE;IACE,gCAAA;IACA,eAAA;IACA,kBAAA;IACA,SAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;EA6SF;EA1SA;IACE,cAAA;IACA,gBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,OAAA;IACA,oBAAA;IACA,4BAAA;IACA,yBAAA;EA4SF;EAzSA;IACE,MAAA;EA2SF;EAxSA;IACE,QAAA;EA0SF;EAvSA;IACE,QAAA;EAySF;EAtSA;IACE,8BAAA;EAwSF;EArSA;IACE,uDAAA;IACA,+DAAA;IACA,4DAAA;IACA,sBAAA;EAuSF;EApSA;IACE,UAAA;EAsSF;EAnSA;IACE,wDAAA;IACA,gEAAA;IACA,6DAAA;IACA,sBAAA;EAqSF;AACF;AAjSA;EACE;IACE,iBAAA;IACA,WAAA;EAmSF;AACF;AAhSA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,QAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,iDAAA;AAkSF;;AA/RA;EACE,eAAA;EACA,uDAAA;EACA,+DAAA;EACA,4DAAA;AAkSF;;AA/RA;EACE,2BAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,QAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,iDAAA;AAkSF;;AA/RA;EACE,sBAAA;AAkSF;;AA/RA;EACE,sBAAA;EACA,6BAAA;AAkSF;;AA/RA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AAkSF;;AA/RA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EAEA,kBAAA;EACA,8BAAA;AAiSF;;AA9RA,OAAA;AACA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAiSF;;AA9RA;EACE,UAAA;AAiSF;;AA9RA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;AAiSF;;AA9RA;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;AAiSF;;AA9RA;EACE,cAAA;AAiSF;;AA9RA;EACE,eAAA;AAiSF;;AA9RA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;AAiSF;;AA9RA;;EAEE,UAAA;EACA,mBAAA;AAiSF;;AA9RA;EACE,aAAA;EACA,kBAAA;EACA,OAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;EACA,uBAAA;EACA,yBAAA;EACA,UAAA;AAiSF;;AA9RA;EACE,cAAA;EACA,gBAAA;AAiSF;;AA9RA;EACE,gBAAA;AAiSF;;AA9RA;;EAEE,aAAA;AAiSF;;AA9RA;EACE,4BAAA;EACA,YAAA;AAiSF;;AA9RA;EACE,YAAA;AAiSF;;AA9RA;EACE,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAiSF;;AA9RA;EACE,cAAA;AAiSF;;AA9RA;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACA,wBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAiSF;;AA9RA;;EAEE,yBAAA;AAiSF;;AA9RA;EACE,iBAAA;EACA,6BAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAiSF;;AA9RA;EACE,iBAAA;EACA,gBAAA;AAiSF;;AA9RA;EACE,qBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAiSF;;AA7RA;EACE,cAAA;AAgSF;;AA7RA;EACE;IACE,kBAAA;EAgSF;EA7RA;IACE,kBAAA;EA+RF;EA5RA;;IAEE,sBAAA;EA8RF;EA3RA;IACE,aAAA;EA6RF;EA1RA;IACE,6BAAA;EA4RF;EAzRA;IACE,kBAAA;EA2RF;AACF;AAxRA,WAAA;AACA;EAEE,iBAAA;AAyRF;;AAtRA;EAIE,aAAA;EACA,eAAA;EACA,mBAAA;AAsRF;;AAjRA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AAoRF;AAlRE;EACE,YAAA;AAoRJ;AAjRE;EATF;IAUI,mBAAA;EAoRF;AACF;;AAjRA;EACE,iBAAA;AAoRF;;AAjRA;EACE,WAAA;EACA,aAAA;AAoRF;;AAjRA;EACE,iBAAA;AAoRF;;AAjRA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAoRF;;AAjRA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;AAoRF;;AAjRA;EACE,qBAAA;AAoRF;;AAjRA;EACE,iBAAA;AAoRF;;AAjRA;EACE,iBAAA;AAoRF;;AA/QA;EACE,oBAAA;AAkRF;;AA/QA;EACE,YAAA;AAkRF;;AA1QA;;EAEE,eAAA;AA6QF;;AA1QA;EACE,eAAA;AA6QF;;AA1QA;EACE,cAAA;AA6QF;;AA1QA;EACE,eAAA;AA6QF;;AA1QA;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AA6QF;;AA1QA;EACE;IACE,YAAA;EA6QF;AACF;AA1QA;EACE;IACE,aAAA;EA4QF;AACF;AAzQA;EACE;IACE,eAAA;EA2QF;EAxQA;IACE,eAAA;EA0QF;AACF;AAvQA;EACE;IACE,eAAA;EAyQF;EAtQA;IACE,YAAA;EAwQF;EAtQA;IACE,eAAA;EAwQF;AACF;AArQA;EACE;IACE,gBAAA;IACA,WAAA;IACA,eAAA;EAuQF;EApQA;IACE,gBAAA;EAsQF;EA/PA;IACE,eAAA;EAiQF;EA9PA;IACE,eAAA;EAgQF;EA7PA;;IAEE,iBAAA;EA+PF;EA5PA;IACE,yBAAA;IACA,iBAAA;EA8PF;EA3PA;IACE,iBAAA;EA6PF;EA1PA;IACE,oBAAA;IACA,iBAAA;EA4PF;EAzPA;IACE,YAAA;EA2PF;EAxPA;;IAEE,eAAA;EA0PF;AACF;AAvPA;EACE;IACE,aAAA;EAyPF;AACF;AAtPA;EACE;IACE,aAAA;EAwPF;EArPA;IACE,aAAA;EAuPF;EApPA;IACE,kBAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;IACA,SAAA;IACA,sBAAA;IACA,sBAAA;IACA,SAAA;IAGA,gBAAA;IAGA,gBAAA;IACA,eAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,0BAAA;IACA,kCAAA;EAsPF;EAnPA;IACE,sBAAA;IACA,0BAAA;IACA,uBAAA;IACA,yBAAA;IACA,eAAA;IACA,kBAAA;IACA,SAAA;IACA,QAAA;IACA,qBAAA;IACA,iDAAA;IACA,+BAAA;EAqPF;EAlPA;IACE,kBAAA;IACA,QAAA;IACA,yBAAA;EAoPF;EAjPA;;IAEE,WAAA;IACA,WAAA;IACA,yBAAA;IACA,cAAA;EAmPF;EAhPA;IACE,eAAA;EAkPF;EA/OA;IACE,cAAA;EAiPF;EA9OA;IACE,WAAA;IACA,oBAAA;IACA,SAAA;IACA,2BAAA;EAgPF;EA7OA;IAGE,0BAAA;EA+OF;EA5OA;IACE,WAAA;IAGA,yBAAA;EA8OF;EA3OA;;IAEE,aAAA;EA6OF;EA1OA;;IAEE,WAAA;EA4OF;AACF;AAzOA,aAAA;AAEA,iBAAA;AACA;EACE,4BAAA;EACA,oCAAA;EACA,8BAAA;AA0OF;;AAvOA;EACE,gCAAA;EACA,oBAAA;AA0OF;;AAvOA;EACE,aAAA;EACA,eAAA;AA0OF;;AAvOA;EACE,eAAA;AA0OF;;AAvOA;EACE,aAAA;EACA,iBAAA;AA0OF;;AAvOA;EACE,8BAAA;AA0OF;;AAvOA;EACE,WAAA;AA0OF;;AAvOA;;;EAGE,gBAAA;EACA,eAAA;EACA,oCAAA;AA0OF;;AAvOA;EACE,UAAA;AA0OF;;AAvOA;EACE,aAAA;EACA,eAAA;AA0OF;;AAvOA;EACE,UAAA;EACA,gBAAA;AA0OF;;AAvOA;EACE,mBAAA;AA0OF;;AAvOA;EACE,aAAA;AA0OF;;AAvOA;EACE,sBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;AA0OF;;AAvOA;EACE,gBAAA;EACA,eAAA;AA0OF;;AAvOA;EACE,kBAAA;AA0OF;;AAvOA;;EAEE,0BAAA;AA0OF;;AAvOA;EACE,wBAAA;AA0OF;;AAvOA;EACE,mBAAA;AA0OF;;AAvOA;EACE,cAAA;EACA,gBAAA;AA0OF;;AAvOA;;EAEE,UAAA;EACA,wBAAA;AA0OF;;AAvOA;;;EAGE,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;AA0OF;;AAvOA;;EAEE,QAAA;AA0OF;;AAvOA;;EAEE,gBAAA;AA0OF;;AAvOA;;EAEE,cAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,sBAAA;AA0OF;;AAvOA;EACE,eAAA;AA0OF;;AAvOA;EACE,gBAAA;AA0OF;;AAvOA;EACE,yBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,gCAAA;EACA,yBAAA;AA0OF;;AAvOA;EACE,UAAA;AA0OF;;AAvOA;EACE,gBAAA;AA0OF;;AAvOA;EACE,mBAAA;AA0OF;;AAvOA;EACE,gBAAA;AA0OF;;AAvOA;EACE,eAAA;EACA,qBAAA;AA0OF;;AAvOA;EACE,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;AA0OF;;AAvOA;EACE,eAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;AA0OF;;AAvOA;EACE,cAAA;AA0OF;;AAvOA;EACE,UAAA;EACA,mBAAA;AA0OF;;AAvOA;EACE,eAAA;AA0OF;;AAvOA;EACE,UAAA;EACA,iBAAA;AA0OF;;AAvOA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;AA0OF;;AAvOA;EACE,mBAAA;EACA,WAAA;AA0OF;;AAvOA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AA0OF;;AAvOA;EACE,WAAA;EACA,gBAAA;AA0OF;;AAvOA;EACE,WAAA;AA0OF;;AAvOA;EAEE;IACE,eAAA;EAyOF;AACF;AAtOA;EAEE;;IAEE,uBAAA;EAuOF;EApOA;IACE,eAAA;EAsOF;AACF;AAlOA;EACE,mBAAA;EACA,UAAA;AAoOF;;AAjOA;EACE,iBAAA;AAoOF;;AAjOA;EACE,2BAAA;AAoOF;;AAjOA;EACE;IACE,4BAAA;EAoOF;EA1NA;;;IAGE,gBAAA;IACA,eAAA;EA4NF;EAtNA;IACE,kBAAA;EAwNF;EArNA;IACE,iBAAA;IACA,WAAA;EAuNF;EApNA;IACE,eAAA;EAsNF;AACF;AAnNA;EACE;IACE,WAAA;IACA,gBAAA;IACA,oBAAA;EAqNF;EAlNA;IACE,WAAA;EAoNF;EAjNA;IACE,WAAA;EAmNF;EAhNA;IACE,eAAA;IACA,iBAAA;IACA,WAAA;EAkNF;AACF;AA/MA;EACE;IACE,iBAAA;EAiNF;EA9MA;IACE,0BAAA;EAgNF;EA7MA;IACE,eAAA;EA+MF;AACF;AA5MA;EACE;IACE,WAAA;IACA,UAAA;IACA,oBAAA;EA8MF;EA3MA;IACE,WAAA;IACA,UAAA;IACA,oBAAA;EA6MF;EA1MA;;;IAGE,eAAA;EA4MF;EAzMA;IACE,0BAAA;EA2MF;AACF;AAxMA;EACE;IACE,WAAA;IACA,mBAAA;EA0MF;AACF;AAvMA,eAAA;AAEA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;AAwMF;AAtME;EANF;IAOI,eAAA;EAyMF;AACF;;AAtMA;EACE,kBAAA;AAyMF;AAvME;EACE,4BDvwDO;ACg9DX;;AArMA;EACE,oBAAA;EACA,mBAAA;AAwMF;AArME;EALF;IAMI,YAAA;EAwMF;AACF;AAtME;EATF;IAUI,YAAA;EAyMF;AACF;AAvME;EAbF;IAcI,aAAA;EA0MF;AACF;AAxME;EAjBF;IAkBI,aAAA;IACA,oBAAA;EA2MF;AACF;AAzME;EAtBF;IAuBI,aAAA;IACA,oBAAA;EA4MF;AACF;AA1ME;EA3BF;IA4BI,aAAA;EA6MF;AACF;AA1ME;EAhCF;IAiCI,WAAA;EA6MF;AACF;;AAzME;EACE,UAAA;EACA,SAAA;EACA,2BAAA;AA4MJ;;AAtMA;EACE,kBAAA;AAyMF;;AAtMA;EACE,mBAAA;EACA,aAAA;EACA,oBAAA;AAyMF;AAvME;EALF;IAMI,aAAA;IACA,oBAAA;EA0MF;AACF;AAnME;EAfF;IAgBI,WAAA;IACA,oBAAA;EAsMF;AACF;;AAjMI;EAFJ;IAGM,aAAA;IACA,oBAAA;EAqMJ;AACF;AAnMI;EAPJ;IAQM,oBAAA;EAsMJ;AACF;AApMI;EAXJ;IAYM,oBAAA;EAuMJ;AACF;AArMI;EAfJ;IAgBM,WAAA;EAwMJ;AACF;;AArMA;EACE,gBAAA;AAwMF;;AArMA;EACE,iBAAA;AAwMF;;AArMA;EACE,YAAA;AAwMF;;AArMA;EACE,SAAA;AAwMF;AAtME;EAHF;IAII,SAAA;EAyMF;AACF;;AAtMA;EACE,OAAA;AAyMF;;AArME;EACE,8BAAA;EACA,2BAAA;AAwMJ;AArME;EANF;IAOI,MAAA;EAwMF;AACF;;AArMA;EACE,aAAA;AAwMF;;AArMA;EACE,cAAA;EACA,0BAAA;EACA,2BAAA;EACA,uCAAA;EACA,sBAAA;EACA,4BAAA;EACA,gCAAA;EACA,4BAAA;AAwMF;;AArMA;EACE,8BAAA;AAwMF;;AArMA;EACE,yBAAA;AAwMF;;AArMA;EACE,sBAAA;EACA,WAAA;EACA,WAAA;EACA,gFAAA;EACA,4BAAA;EACA,6BAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,2BAAA;AAwMF;;AArMA;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;EACA,oCAAA;AAwMF;AAtME;EACE,kBAAA;AAwMJ;;AApMA;EACE,kBAAA;AAuMF;;AApMA;EACE,eAAA;EACA,2BAAA;EACA,uCAAA;EACA,sBAAA;EACA,iBAAA;AAuMF;;AApMA;EACE,sBAAA;AAuMF;;AApMA;EACE,4BAAA;AAuMF;;AApMA;EACE,qBAAA;EACA,eAAA;EACA,2BAAA;EACA,uCAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;AAuMF;;AApMA;EACE,yBAAA;EACA,qBAAA;AAuMF;;AApMA;EACE;IACE,aAAA;EAuMF;AACF;AApMA;EACE;IACE,gBAAA;IACA,2BAAA;IACA,6CAAA;IACA,wCAAA;IACA,mBAAA;IACA,6BAAA;IACA,oBAAA;IACA,kBAAA;IACA,2BAAA;EAsMF;EAnMA;IACE,2CAAA;EAqMF;EAlMA;IACE,iCAAA;IACA,yBAAA;IACA,0BAAA;IACA,2BAAA;IACA,uCAAA;IACA,4BAAA;IACA,gCAAA;IACA,0BAAA;IACA,gBAAA;EAoMF;EAjMA;IACE,yBAAA;EAmMF;EA9LE;IACE,mBAAA;EAgMJ;AACF;AAvLA;EACE,SAAA;AAyLF;;AArLA;EACE,sBAAA;EAEA,wBAAA;AAuLF;;AApLA;EACE,4BAAA;EACA,mBAAA;EACA,wBAAA;EACA,UAAA;AAuLF;;AApLA;;EAEE,aAAA;EACA,sBAAA;EACA,SAAA;AAuLF;;AApLA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;AAuLF;AArLE;EALF;IAMI,SAAA;EAwLF;AACF;;AArLA;EACE,aAAA;AAwLF;AAtLE;EAHF;IAII,WAAA;EAyLF;AACF;;AAtLA;EAEE,gBAAA;EACA,WAAA;AAwLF;AAtLE;EALF;IAMI,gBAAA;EAyLF;AACF;;AAtLA;EACE,WAAA;AAyLF;;AAtLA;EACE,eAAA;EACA,uCAAA;EACA,WAAA;EACA,iBAAA;AAyLF;AAvLE;EANF;IAOI,eAAA;EA0LF;AACF;;AAvLA;EACE,gBAAA;AA0LF;AAxLE;EAHF;IAII,eAAA;EA2LF;AACF;;AAxLA;EACE,gBAAA;AA2LF;AAzLE;EAHF;IAII,eAAA;EA4LF;AACF;;AAzLA;EACE,gBAAA;AA4LF;AA1LE;EAHF;IAII,eAAA;EA6LF;AACF;;AAzLA;EACE,eAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AA4LF;;AAzLA;EACE,cAAA;EACA,cAAA;EACA,mBAAA;AA4LF;;AAzLA;EACE,WAAA;EACA,cAAA;EACA,eAAA;EACA,uCAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;AA4LF;;AAzLA;EACE,0BAAA;AA4LF;;AAzLA;EACE,+BAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;AA4LF;AA1LE;EANF;IAOI,gBAAA;EA6LF;AACF;AA3LE;EAVF;IAWI,eAAA;EA8LF;AACF;;AA3LA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AA8LF;;AA3LA;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;AA8LF;AA5LE;EACE,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,eAAA;EACA,4BDrrEO;ECsrEP,eAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AA8LJ;AA5LI;EACE,yBAAA;EACA,qBAAA;AA8LN;;AAzLA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AA4LF;;AAzLA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AA4LF;AA1LE;EACE,mBAAA;AA4LJ;AAzLE;EACE,YAAA;EACA,WAAA;EACA,UAAA;AA2LJ;AAxLE;EACE,UAAA;AA0LJ;;AAtLA;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;AAyLF;AAvLE;EARF;IASI,WAAA;EA0LF;AACF;;AAvLA;EACE,iBAAA;EACA,kBAAA;AA0LF;;AAvLA;EACE,kBAAA;EACA,mBAAA;AA0LF;;AAvLA;EACE,cAAA;EACA,qBAAA;AA0LF;AAxLE;EACE,0BAAA;AA0LJ;;AAtLA;EACE,sBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;AAyLF;;AAtLA;EACE,aAAA;AAyLF;AAvLE;EACE,OAAA;EACA,SAAA;AAyLJ;AAtLE;EACE,sBAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;EACA,+BAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;AAwLJ;AArLE;EACE,cAAA;EACA,UAAA;AAuLJ;AApLE;EACE,aAAA;AAsLJ;AAnLE;EACE,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,SAAA;EACA,WAAA;EACA,uCAAA;EACA,gBAAA;AAqLJ;AApLI;EACE,mBAAA;EACA,eAAA;AAsLN;;AA/KA;EACE,wBAAA;AAkLF;;AA/KA;EACE,+BAAA;AAkLF;AAhLE;EAHF;IAII,+BAAA;EAmLF;AACF;AAjLE;EACE,iBAAA;AAmLJ;AA/KI;EADF;IAEI,mBAAA;EAkLJ;AACF;AA/KE;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAiLJ;AA/KI;EACE,eAAA;EACA,4BD51EK;EC61EL,WAAA;EACA,qBAAA;EACA,SAAA;AAiLN;AA/KM;EAPF;IAQI,eAAA;EAkLN;AACF;AA/KI;EACE,eAAA;EACA,4BDx2EK;ECy2EL,iBAAA;EACA,WAAA;AAiLN;AA9KI;EACE,eAAA;EACA,gBAAA;EACA,4BDh3EK;ECi3EL,WAAA;EACA,qBAAA;AAgLN;AA9KM;EACE,4BDr3EG;ECs3EH,WAAA;EACA,0BAAA;AAgLR;AA7KM;EAbF;IAcI,eAAA;EAgLN;AACF;AA7KI;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,eAAA;EACA,4BDx4EK;ECy4EL,eAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AA+KN;AA7KM;EACE,yBAAA;EACA,qBAAA;AA+KR;;AAvKA;EACE,kBAAA;EACA,YAAA;AA0KF;;AAvKA;EACE,wBAAA;EACA,cAAA;AA0KF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","// @import './../../../../../../assets/styles/variables';\n@import './../../../../assets//styles/variables';\n.pagecenter {\n  width: 100%;\n  padding: 0 15px;\n  margin: 0 auto;\n\n  @media only screen and (min-width: 540px) {\n    max-width: 540px;\n  }\n\n  @media only screen and (min-width: 768px) {\n    max-width: 750px;\n  }\n\n  @media only screen and (min-width: 992px) {\n    max-width: 960px;\n  }\n\n  @media only screen and (min-width: 1200px) {\n    max-width: 1170px;\n  }\n}\n\n.f-flex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n// header\n\n.header {\n  position: relative;\n  border-top: 10px solid #6D6E70;\n  padding: 18px 0;\n  background-color: #fff;\n  z-index: 999;\n\n  @media only screen and (max-width: 1120px) {\n    border-top-width: 5px;\n  }\n\n  &__inner {\n    position: relative;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n\n    @media only screen and (max-width: 1120px) {\n      padding-right: 38px;\n    }\n\n    @media only screen and (max-width: 767px) {\n      padding-right: 35px;\n    }\n  }\n\n  & a:hover {\n    text-decoration: none;\n  }\n\n  &__logo {\n    width: 270px;\n\n    img {\n      max-width: 100%;\n    }\n\n    @media only screen and (max-width: 1400px) {\n      width: 200px;\n    }\n\n    @media only screen and (max-width: 767px) {\n      width: 100px;\n    }\n  }\n\n  &__right {\n    margin-left: auto;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n\n    &>*+* {\n      margin-left: 26px;\n\n      @media only screen and (max-width: 1400px) {\n        margin-left: 16px;\n      }\n    }\n  }\n\n  &__search,\n  &__cart {\n    img {\n      width: 28px;\n\n      @media only screen and (max-width: 767px) {\n        width: 18px;\n      }\n    }\n  }\n\n  &__cart {\n    padding: 8px 0;\n    position: relative;\n\n    &>a {\n      position: relative;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      align-items: center;\n    }\n\n    i {\n      width: 28px;\n      height: 28px;\n      background-image: url('https://metjbxcucs-flywheel.netdna-ssl.com/wp-content/uploads/2020/03/foursight-cart-icon.svg');\n      background-position: center center;\n      background-repeat: no-repeat;\n      background-size: contain;\n\n      &::before {\n        display: none;\n      }\n\n      @media only screen and (max-width: 767px) {\n        width: 18px;\n        height: 18px;\n      }\n    }\n\n    &count {\n      position: absolute;\n      top: -14px;\n      left: 15px;\n      background-color: #7BBC43;\n      color: #fff;\n      width: 25px;\n      height: 25px;\n      border-radius: 50%;\n      line-height: 26px;\n      font-size: 12px;\n      font-family: 'Museo-700';\n      text-align: center;\n\n      @media only screen and (max-width: 767px) {\n        top: -13px;\n        left: 8px;\n        width: 22px;\n        height: 22px;\n        line-height: 23px;\n        font-size: 11px;\n      }\n    }\n  }\n\n  &__menu {\n    margin-right: 0;\n\n    @media only screen and (max-width: 1120px) {\n      display: none;\n      position: absolute;\n      top: calc(100% + 19px);\n      left: 0;\n      background-color: #fff;\n      margin: 0;\n      width: 100%;\n      z-index: 99;\n      box-shadow: 0 10px 10px rgba(0, 0, 0, 0.05);\n    }\n\n    .menu {\n      margin-bottom: 0;\n      padding: 0;\n      margin-left: auto;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n\n      li {\n        list-style: none;\n        margin: 0;\n\n        a {\n          display: inline-block;\n          text-decoration: none;\n          position: relative;\n          font-family: 'Museo-700' !important;\n          font-size: 18px;\n          color: #6D6E70;\n          line-height: 1.5;\n\n          &:hover {\n            color: #7BBC43;\n          }\n\n          @media only screen and (max-width: 1120px) {\n            width: 100% !important;\n            display: block;\n            padding: 8px 15px;\n          }\n\n          @media only screen and (max-width: 767px) {\n            font-size: 16px;\n          }\n        }\n\n        &.active,\n        &.current-menu-item {\n          a {\n            color: #7BBC43;\n          }\n        }\n      }\n\n      &>li {\n        position: relative;\n\n        @media only screen and (max-width: 1120px) {\n          width: 100%;\n        }\n\n        &+li {\n          margin-left: 38px;\n\n          @media only screen and (max-width: 1400px) {\n            margin-left: 26px;\n          }\n\n          @media only screen and (max-width: 1120px) {\n            margin-left: 0;\n            border-top: 1px dashed #ccc;\n          }\n        }\n\n        &>a {\n          padding-top: 7px;\n          padding-bottom: 7px;\n        }\n\n        &>ul {\n          position: absolute;\n          top: 100%;\n          left: 0;\n          display: none;\n          background: #fff;\n          box-shadow: 0 0 30px rgba(0, 0, 0, 0.07);\n          width: 240px;\n          padding: 10px 0;\n          border-radius: 3px;\n          z-index: 99;\n\n          a {\n            font-size: 14px;\n            font-family: 'Museo-300' !important;\n            display: block;\n            padding: 5px 15px;\n          }\n\n          @media only screen and (max-width: 1120px) {\n            position: static;\n            width: 100%;\n            box-shadow: none;\n            padding: 0 0 10px;\n\n            a {\n              &::before {\n                content: \"-\";\n                margin-right: 5px;\n              }\n            }\n          }\n        }\n\n        &:hover ul {\n          @media only screen and (min-width: 1121px) {\n            display: block;\n          }\n        }\n\n        &.menu-item-has-children {\n          &>a {\n            padding-right: 20px;\n\n            &::after {\n              content: \"\";\n              width: 12px;\n              height: 12px;\n              background-image: url(https://metjbxcucs-flywheel.netdna-ssl.com/wp-content/uploads/2020/03/caret-down.svg);\n              background-repeat: no-repeat;\n              background-position: center center;\n              background-size: contain;\n              display: inline-block;\n              position: absolute;\n              top: 50%;\n              right: 0;\n              -webkit-transform: translateY(-50%);\n              -ms-transform: translateY(-50%);\n              transform: translateY(-50%);\n              -webkit-transition: all ease 0.3s;\n              -o-transition: all ease 0.3s;\n              transition: all ease 0.3s;\n\n              @media only screen and (max-width: 1120px) {\n                right: 15px;\n              }\n            }\n\n            &.header__submenuopen::after {\n              -webkit-transform: translateY(-50%) rotate(-180deg);\n              -ms-transform: translateY(-50%) rotate(-180deg);\n              transform: translateY(-50%) rotate(-180deg);\n            }\n          }\n        }\n      }\n    }\n  }\n\n  &__cta {\n    @media only screen and (max-width: 1400px) {\n      width: 21px;\n    }\n\n    @media only screen and (max-width: 767px) {\n      margin-left: 16px !important;\n    }\n\n    a {\n      display: inline-block;\n      background: #7BBC43;\n      color: #fff;\n      padding: 8px 23px;\n      font-size: 18px;\n      font-family: 'Museo-700' !important;\n      text-transform: capitalize;\n      text-decoration: none;\n\n      &:hover,\n      &:focus {\n        background: #6D6E70;\n        color: #fff;\n        text-decoration: none;\n      }\n\n      @media only screen and (max-width: 767px) {\n        font-size: 11px;\n        padding: 6px 10px;\n      }\n    }\n  }\n\n  &__toggler {\n    position: absolute;\n    right: 0;\n    display: none;\n    cursor: pointer;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n\n    i {\n      color: #484848;\n      font-size: 24px;\n\n      @media only screen and (max-width: 767px) {\n        font-size: 21px;\n      }\n    }\n\n    &:hover i {\n      color: #69BE28;\n    }\n\n    @media only screen and (max-width: 1120px) {\n      display: block;\n    }\n  }\n\n  &__search {\n    position: relative;\n  }\n}\n\n// sitefooter\n\n.f-flexrow {\n  margin: 0 -15px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n\n  &>* {\n    padding: 0 15px;\n  }\n}\n\n::ng-deep.sitefooter {\n  background-color: #6D6E70;\n  padding: 80px 0 50px;\n  font-family: 'Museo-300' !important;\n\n  &__toplogo {\n    position: relative;\n    padding-bottom: 30px;\n    margin-bottom: 30px;\n\n    &::after {\n      content: \"\";\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      width: 40px;\n      height: 2px;\n      background: #f7f7f7;\n    }\n\n    a {\n      img {\n        width: 188px;\n      }\n    }\n  }\n\n  &__inner {\n    margin: 0 -15px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n  }\n\n  &__left {\n    width: 66%;\n\n    @media screen and (max-width: 991px) {\n      width: 100%;\n    }\n\n    &col {\n      width: calc(100% / 2);\n      margin-bottom: 40px;\n\n      @media screen and (max-width: 580px) {\n        width: 100%;\n      }\n    }\n\n    &cell {\n      &>div+div {\n        margin-top: 40px;\n\n        &.status-site {\n          margin-top: 9px;\n\n          h6 {\n            font-family: 'Museo-300' !important;\n            font-size: 17px;\n            margin-top: 0;\n          }\n\n          .up-status {\n            a {\n              color: #7BBC43;\n\n              &:hover {\n                text-decoration: none;\n                border-bottom: 0;\n              }\n            }\n          }\n        }\n      }\n\n      ul {\n        li {\n          &+li {\n            margin-top: 10px;\n          }\n        }\n      }\n\n      a {\n        text-decoration: none;\n        display: inline;\n        border-bottom: 1px solid transparent;\n\n        &:hover {\n          opacity: 1;\n          border-bottom-color: #fff;\n        }\n      }\n    }\n  }\n\n  &__right {\n    width: 33%;\n\n    @media screen and (max-width: 991px) {\n      width: 100%;\n    }\n\n    &>*+* {\n      margin-top: 30px;\n    }\n  }\n\n  h6 {\n    color: #fff !important;\n    font-size: 20px;\n    text-transform: none;\n    margin: 0 0 15px;\n    font-family: 'Museo-700' !important;\n\n    span {\n      color: #69BE28;\n    }\n  }\n\n  ul {\n    padding: 0;\n    margin: 0;\n  }\n\n  li {\n    line-height: 1.1;\n    list-style: none;\n    margin-bottom: 0;\n  }\n\n  a {\n    line-height: 1.2;\n    color: #fff;\n    font-size: 16px;\n\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n\n  &__newsletter {\n    h6 {\n      margin-bottom: 2px;\n    }\n\n    p {\n      color: #fff;\n      font-size: 16px;\n      margin-bottom: 10px;\n      line-height: 1.4;\n\n      a {\n        text-decoration: underline;\n\n        &:hover {\n          text-decoration: none;\n          color: #fff;\n        }\n      }\n    }\n  }\n\n  &__social ul {\n    padding-top: 4px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n\n    li {\n      &:not(:last-child) {\n        margin-right: 15px;\n      }\n\n      a {\n        display: inline-block;\n        width: 40px;\n        height: 40px;\n        background: #fff;\n        position: relative;\n\n        img {\n          width: 21px;\n          position: absolute;\n          top: 50%;\n          left: 50%;\n          -webkit-transform: translate(-50%, -50%);\n          -ms-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n        }\n      }\n    }\n  }\n\n  &bottom {\n    background: #fff;\n    padding: 30px 0;\n\n    &__col {\n      width: 33%;\n    }\n\n    &__cell {\n\n      p,\n      a {\n        margin: 0;\n        font-size: 16px;\n        color: #6D6E70;\n      }\n\n      a {\n        text-decoration: underline;\n\n        &:hover {\n          opacity: 0.8;\n          text-decoration: none;\n          color: #6D6E70;\n        }\n      }\n    }\n  }\n\n  &__hbsptform {\n    .hbsptform .hs-form-field {\n      width: 100% !important;\n      padding-right: 0 !important;\n      margin-bottom: 12px;\n    }\n\n    span.hs-form-required {\n      display: none !important;\n    }\n\n    .hs_email {\n      width: 100% !important;\n      padding-right: 0 !important;\n      margin-bottom: 12px;\n\n      label {\n        display: none;\n      }\n    }\n\n    .submitted-message {\n      color: #fff !important;\n      background: #5cb85c;\n      padding: 15px !important;\n      text-align: center;\n    }\n\n    input {\n      height: 50px;\n      padding: 10px 15px !important;\n      font-size: 16px !important;\n      width: 100% !important;\n      max-width: 100% !important;\n      color: #464a4c !important;\n      box-shadow: none !important;\n\n      &:not([type=\"checkbox\"]):not([type=\"radio\"]) {\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n      }\n\n      &[type=\"email\"] {\n        border: 1px solid #ccc !important;\n      }\n\n      &[type=\"submit\"] {\n        padding: 0 !important;\n        text-transform: uppercase;\n        font-family: 'Museo-700' !important;\n        background-color: #7BBC43 !important;\n        margin: 0 !important;\n        width: 100% !important;\n        max-width: 200px !important;\n        color: #fff !important;\n        border: 0;\n        -webkit-transition: all .2s ease-in-out;\n        -o-transition: all .2s ease-in-out;\n        transition: all .2s ease-in-out;\n\n        &:hover {\n          background-color: #000 !important;\n        }\n      }\n    }\n\n    .legal-consent-container {\n      text-align: left;\n\n      .hs-richtext {\n        margin-bottom: 11px;\n\n        p {\n          font-size: 12px;\n        }\n      }\n\n      label {\n        display: block !important;\n        position: relative;\n        padding-left: 20px;\n        margin-bottom: 0;\n\n        input {\n          margin-top: 0;\n          position: absolute;\n          top: 3px;\n          left: 0;\n          width: auto !important;\n          height: auto !important;\n        }\n\n        span {\n          margin: 0;\n          display: block;\n        }\n\n        p {\n          font-size: 12px;\n        }\n      }\n    }\n\n    .hs_submit {\n      width: 100%;\n    }\n\n    .hs-error-msgs.inputs-list label {\n      color: #fff;\n      font-size: 11px;\n      font-family: 'Museo-300' !important;\n      margin: 4px 0 0;\n    }\n  }\n}\n\n.products-grid {\n  overflow: hidden;\n}\n\n//new header\n\n@import url('https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Abel&display=swap');\n\n* {\n  box-sizing: border-box;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\nbody {\n  font-family: 'Museo';\n}\n\n/*header*/\n@media screen and (max-width: 1080px) {\n  .mobile-trigger {\n    display: inline-block !important;\n    cursor: pointer;\n    position: absolute;\n    top: 40px;\n    right: 20px;\n    width: 35px;\n    height: 25px;\n    z-index: 1;\n  }\n\n  .mobile-trigger .line {\n    display: block;\n    background: #fff;\n    width: 35px;\n    height: 3px;\n    position: absolute;\n    left: 0;\n    transition: all .4s;\n    -webkit-transition: all .4s;\n    -moz-transition: all .4s;\n  }\n\n  .mobile-trigger .line.line-1 {\n    top: 0;\n  }\n\n  .mobile-trigger .line.line-2 {\n    top: 36%;\n  }\n\n  .mobile-trigger .line.line-3 {\n    top: 71%;\n  }\n\n  .mobile-trigger .line {\n    background: #6d6e70 !important;\n  }\n\n  .mobile-trigger.active-re .line-1 {\n    transform: translateY(11px) translateX(0) rotate(45deg);\n    -webkit-transform: translateY(11px) translateX(0) rotate(45deg);\n    -moz-transform: translateY(11px) translateX(0) rotate(45deg);\n    background-color: #fff;\n  }\n\n  .mobile-trigger.active-re .line-2 {\n    opacity: 0;\n  }\n\n  .mobile-trigger.active-re .line-3 {\n    transform: translateY(-7px) translateX(0) rotate(-45deg);\n    -webkit-transform: translateY(-7px) translateX(0) rotate(-45deg);\n    -moz-transform: translateY(-7px) translateX(0) rotate(-45deg);\n    background-color: #fff;\n  }\n\n}\n\n@media screen and (max-width: 1440px) {\n  .frsight-hdr-top .container {\n    max-width: 1240px;\n    width: 100%;\n  }\n}\n\n.bm-nav-fixed1 {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  right: 0;\n  margin: 0 auto;\n  transition: .5s ease all;\n  z-index: 998;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.frsight-hdr-top.bm-nav-fixed1.sticky {\n  position: fixed;\n  box-shadow: 0px 3px 12px -5px rgb(109 110 112 / 75%);\n  -webkit-box-shadow: 0px 3px 12px -5px rgb(109 110 112 / 75%);\n  -moz-box-shadow: 0px 3px 12px -5px rgba(109, 110, 112, 0.75);\n}\n\n.bm-nav-sticky {\n  position: sticky !important;\n  top: 0;\n  left: 0;\n  width: 100%;\n  right: 0;\n  margin: 0 auto;\n  transition: .5s ease all;\n  z-index: 998;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.frsight-hdr {\n  background-color: #eee;\n}\n\n.bm-nav-fixed1.sticky .frsight-hdr {\n  background-color: #fff;\n  border-top: 5px solid #6d6e70;\n}\n\n.container {\n  max-width: 1570px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.frsight-hdr-inner {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  // min-height: 122px;\n  position: relative;\n  justify-content: space-between;\n}\n\n/*menu*/\n.bm-menu-mixed ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.bm-menu-mixed ul li {\n  padding: 0;\n}\n\n.bm-menu-mixed ul.menu {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: flex-end;\n}\n\n.bm-menu-mixed ul.menu>li {\n  margin: 0px 16.5px;\n  position: relative;\n  padding-bottom: 52px;\n  padding-top: 52px;\n  line-height: 1.4;\n}\n\n.bm-menu-mixed ul.menu>li:first-child {\n  margin-left: 0;\n}\n\n.bm-menu-mixed ul.menu>li:last-child {\n  margin-right: 0;\n}\n\n.bm-menu-mixed ul.menu>li::after {\n  position: absolute;\n  content: \"\";\n  width: auto;\n  height: 4px;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  background-color: #7bbd43;\n  opacity: 0;\n  visibility: hidden;\n  transition: .5s ease all;\n}\n\n.bm-menu-mixed ul.menu>li.active::after,\n.bm-menu-mixed ul.menu>li:hover::after {\n  opacity: 1;\n  visibility: visible;\n}\n\n.bm-menu-mixed ul.menu>li>ul {\n  display: none;\n  position: absolute;\n  left: 0;\n  width: 100%;\n  top: 100%;\n  border: 1px solid #fff;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  background-color: #696969;\n  z-index: 1;\n}\n\n.bm-menu-mixed ul.menu>li.hs-menu-item:hover>ul.hs-menu-children-wrapper {\n  display: block;\n  min-width: 206px;\n}\n\n.bm-menu-mixed ul.menu>li:hover>ul.hs-menu-children-wrapper.menu-col-2 {\n  min-width: 460px;\n}\n\n.bm-menu-mixed ul.menu>li.hs-menu-item.active>ul.menu-col-2,\n.bm-menu-mixed ul.menu>li.hs-menu-item:hover>ul.menu-col-2 {\n  display: flex;\n}\n\n.bm-menu-mixed ul.menu>li.hs-menu-item>ul.menu-col-2>li:first-child {\n  border-right: 1px solid #fff;\n  width: 36.5%;\n}\n\n.bm-menu-mixed ul.menu>li.hs-menu-item>ul.menu-col-2>li:last-child {\n  width: 63.5%;\n}\n\n.bm-menu-mixed ul.menu>li.hs-menu-item>a {\n  color: #3d3d3d;\n  text-decoration: none;\n  font-size: 18px;\n  font-weight: 700;\n  position: relative;\n}\n\n.bm-menu-mixed ul.menu li:hover>a {\n  color: #7bbd43;\n}\n\n.bm-menu-mixed ul.menu>li.hs-menu-item.hs-item-has-children>a:after {\n  content: \"\\f107\";\n  position: absolute;\n  bottom: -30px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  font-family: fontawesome;\n  font-size: 18px;\n  color: #343435;\n  text-align: center;\n}\n\n.bm-menu-mixed ul.menu>li.hs-menu-item.hs-item-has-children.active>a:after,\n.bm-menu-mixed ul.menu>li.hs-menu-item.hs-item-has-children:hover>a:after {\n  color: #7bbd43 !important;\n}\n\n.bm-menu-mixed ul.menu>li.hs-menu-item>ul>li>a {\n  padding: 5px 15px;\n  border-bottom: 1px solid #fff;\n  display: block;\n  text-decoration: none;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.bm-menu-mixed ul.menu>li.hs-menu-item>ul>li>ul>li {\n  padding: 5px 15px;\n  text-align: left;\n}\n\n.bm-menu-mixed ul.menu>li.hs-menu-item>ul li a {\n  text-decoration: none;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 700;\n\n}\n\n.bm-menu-mixed ul.menu>li.hs-menu-item>ul li:hover>a {\n  color: #7bbd43;\n}\n\n@media screen and (max-width: 1080px) {\n  .bm-menu-mixed ul.menu>li>ul {\n    position: relative;\n  }\n\n  .bm-menu-mixed ul.menu>li>ul>li.hs-item-has-children>.child-trigger {\n    border-color: #fff;\n  }\n\n  .bm-menu-mixed ul.menu>li>ul>li.hs-item-has-children>.child-trigger i,\n  .bm-menu-mixed ul.menu>li>ul>li.hs-item-has-children>.child-trigger i::after {\n    background-color: #fff;\n  }\n\n  .bm-menu-mixed ul.menu>li>ul>li.hs-item-has-children>ul {\n    display: none;\n  }\n\n  .bm-menu-mixed ul.menu>li.hs-menu-item>ul>li>a {\n    padding: 12px 15px !important;\n  }\n\n  .bm-menu-mixed ul.menu>li>ul>li.hs-item-has-children {\n    position: relative;\n  }\n}\n\n/*End menu*/\n.bm-menu-mixed {\n  // width: calc(100% - 849px);\n  padding: 0px 20px;\n}\n\n.frsight-hdr-right {\n  // max-width: 514px;\n  // max-width: 470px;\n  // width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  // justify-content: flex-end;\n  // margin-left: auto;\n}\n\n.frsight-hdr-right-box {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n\n  &.pos-abs {\n    bottom: -4px;\n  }\n\n  @media screen and (max-width: 1080px) {\n    padding-right: 40px;\n  }\n}\n\n.frsight-hdr-right-box .frsight-user-icon {\n  margin-right: 7px;\n}\n\n.frsight-hdr-right-box svg {\n  width: 20px;\n  fill: #6d6e70;\n}\n\n.frsight-hdr-right-box.fr-left-space1 {\n  margin-left: 33px;\n}\n\n.frsight-hdr-cta a {\n  background-color: #7bbd43;\n  border: 1px solid #7bbd43;\n  border-radius: 2px;\n  color: #fff;\n  text-decoration: none;\n  padding: 15px 20px;\n  font-size: 20px;\n  line-height: normal;\n  font-weight: 700;\n  letter-spacing: 1px;\n  display: inline-block;\n  position: relative;\n  font-family: Museo;\n}\n\n.frsight-hdr-right-box p {\n  font-size: 17px;\n  font-weight: 700;\n  margin: 0px;\n  color: #454343;\n}\n\n.frsight-login a {\n  text-decoration: none;\n}\n\n.frsight-hdr-right-box.fr-left-space1 {\n  margin-left: 33px;\n}\n\n.frsight-hdr-cta {\n  margin-left: 25px;\n}\n\n\n\n.bm-nav-fixed1.sticky .bm-menu-mixed .hs-menu-wrapper>ul>li {\n  padding-bottom: 30px;\n}\n\n.bm-logo-img {\n  width: 335px;\n  // padding: 37px 0;\n}\n\n.bm-menu-mixed {\n  // width: calc(100% - 669px);\n}\n\n.bm-menu-mixed li.hs-menu-item.hs-menu-depth-1>a,\n.frsight-hdr-right-box p {\n  font-size: 16px;\n}\n\n.bm-menu-mixed ul.menu>li.hs-menu-item>a {\n  font-size: 18px;\n}\n\n.bm-menu-mixed ul.menu>li.hs-menu-item:nth-child(2)>a {\n  color: #7bbd43;\n}\n\n.bm-menu-mixed ul.menu>li.hs-menu-item>ul li a {\n  font-size: 14px;\n}\n\n.frsight-hdr-cta a {\n  padding: 10px 20px;\n  font-size: 12px;\n  line-height: normal;\n  font-weight: 700;\n  letter-spacing: 1px;\n  display: inline-block;\n  position: relative;\n  font-family: Museo;\n}\n\n@media (max-width: 1850px) {\n  .bm-logo-img {\n    width: 260px;\n  }\n}\n\n@media (max-width: 1440px) {\n  .bm-menu-mixed ul.menu>li {\n    margin: 0 8px;\n  }\n}\n\n@media screen and (max-width: 1400px) {\n  .frsight-hdr-right-box p {\n    font-size: 16px;\n  }\n\n  .bm-menu-mixed ul.menu>li.hs-menu-item>a {\n    font-size: 16px;\n  }\n}\n\n@media screen and (max-width: 1300px) {\n  .frsight-hdr-right-box p {\n    font-size: 14px;\n  }\n\n  .bm-logo-img {\n    width: 230px;\n  }\n  .bm-menu-mixed ul.menu>li.hs-menu-item>a {\n    font-size: 14px;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .bm-logo-img {\n    max-width: 190px;\n    width: 100%;\n    padding: 32px 0;\n  }\n\n  .frsight-hdr-right {\n    max-width: 378px;\n  }\n\n  // .frsight-hdr-cta a {\n  //   padding: 11px 15px;\n  // }\n\n  .bm-menu-mixed ul.menu>li.hs-menu-item>a {\n    font-size: 16px;\n  }\n\n  .bm-menu-mixed ul.menu>li {\n    margin: 0px 6px;\n  }\n\n  .frsight-hdr-right-box.fr-left-space1,\n  .frsight-hdr-cta {\n    margin-left: 12px;\n  }\n\n  .bm-menu-mixed {\n    width: calc(100% - 568px);\n    padding: 0px 15px;\n  }\n\n  .frsight-hdr-inner {\n    min-height: 100px;\n  }\n\n  .bm-menu-mixed ul.menu>li {\n    padding-bottom: 37px;\n    padding-top: 37px;\n  }\n\n  .bm-logo-img {\n    width: 180px;\n  }\n\n  .bm-menu-mixed ul.menu>li.hs-menu-item>a,\n  .frsight-hdr-right-box p {\n    font-size: 13px;\n  }\n}\n\n@media screen and (min-width: 1081px) {\n  .frsight-hdr-right.hide-desk {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 1080px) {\n  .frsight-hdr-right {\n    display: none;\n  }\n\n  .bm-menu__inner {\n    display: none;\n  }\n\n  .bm-menu__inner {\n    padding: 15px 20px;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    margin: 0;\n    background-image: none;\n    background-color: #fff;\n    border: 0;\n    -webkit-border-radius: 0;\n    -moz-border-radius: 0;\n    border-radius: 0;\n    -webkit-box-shadow: none;\n    -moz-box-shadow: none;\n    box-shadow: none;\n    max-width: none;\n    width: 100%;\n    height: auto;\n    z-index: 9;\n    border-top: 1px solid #000;\n    box-shadow: #ccc 2px 5px 10px -2px;\n  }\n\n  .child-trigger {\n    width: 30px !important;\n    min-width: 30px !important;\n    height: 21px !important;\n    display: block !important;\n    cursor: pointer;\n    position: absolute;\n    top: 12px;\n    right: 0;\n    padding: 0 !important;\n    /*border-left: 1px dotted rgba(255,255,255,.20);*/\n    border-left: 2px dotted #6d6e70;\n  }\n\n  .child-trigger i {\n    position: relative;\n    top: 50%;\n    margin: 0 auto !important;\n  }\n\n  .child-trigger i,\n  .child-trigger i:after {\n    width: 10px;\n    height: 2px;\n    background-color: #6d6e70;\n    display: block;\n  }\n\n  .bm-menu-mixed ul.menu>li:first-child {\n    border-top: 0px;\n  }\n\n  .bm-menu-mixed ul.menu>li.hs-menu-item>a {\n    color: #6d6e70;\n  }\n\n  .bm-menu-mixed ul.menu>li {\n    width: 100%;\n    padding: 12px 0 20px;\n    margin: 0;\n    border-top: 1px dashed #ccc;\n  }\n\n  .child-trigger.child-open i:after {\n    -webkit-transform: rotate(-180deg);\n    -ms-transform: rotate(-180deg);\n    transform: rotate(-180deg);\n  }\n\n  .child-trigger i::after {\n    content: \"\";\n    -webkit-transform: rotate(-90deg);\n    -ms-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n  }\n\n  .bm-menu-mixed ul.menu>li.hs-menu-item.hs-item-has-children>a:after,\n  .bm-menu-mixed ul.menu>li::after {\n    display: none;\n  }\n\n  .bm-menu-mixed ul.menu>li.hs-menu-item>ul.menu-col-2>li:last-child,\n  .bm-menu-mixed ul.menu>li.hs-menu-item>ul.menu-col-2>li:first-child {\n    width: 100%;\n  }\n}\n\n/*End header*/\n\n/* start footer */\n.frsight-footer-bg {\n  background-repeat: no-repeat;\n  background-color: rgba(109, 110, 112, 1.0);\n  background-position: 108% 132%;\n}\n\n.frsight-footer-bg .frsight-footertop {\n  border-bottom: 2px solid #7bbd43;\n  padding-bottom: 60px;\n}\n\n.dis-flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.frsight-footer-bg .frsight-footertop-box:first-child {\n  padding-left: 0;\n}\n\n.frsight-footer-bg .frsight-footertop-box {\n  width: 33.33%;\n  padding: 0px 20px;\n}\n\n.frsight-footer-bg .frsight-footer-box-hdr h6 {\n  margin-bottom: 25px !important;\n}\n\n.frsight-footer-bg * {\n  color: #fff;\n}\n\n.frsight-footer-bg p,\n.frsight-footer-bg ul li,\n.frsight-footer-bg ul li a {\n  font-weight: 300;\n  font-size: 19px;\n  font-family: 'Open Sans', sans-serif;\n}\n\n.frsight-footer-bg .frsight-footertop-right {\n  width: 40%;\n}\n\n.frsight-footer-bg form {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.frsight-footer-bg .hs_email.hs-email.hs-fieldtype-text.field.hs-form-field {\n  width: 70%;\n  margin-bottom: 0;\n}\n\n.hs-form-field {\n  margin-bottom: 24px;\n}\n\n.frsight-footer-bg form .hs_email.hs-email>label {\n  display: none;\n}\n\n.frsight-footer-bg form input[type=email] {\n  background-color: #fff;\n  box-shadow: none;\n  border: 0;\n  color: #51668a;\n  font-size: 18px;\n  padding: .7rem;\n  width: 100%;\n  border-radius: 3px;\n  display: inline-block;\n}\n\n.frsight-footer-bg form .inputs-list {\n  list-style: none;\n  padding-left: 0;\n}\n\n.hs-form-booleancheckbox span {\n  padding-left: 28px;\n}\n\n.hs-form-booleancheckbox span,\n.hs-form-booleancheckbox span a {\n  font-size: 15px !important;\n}\n\n.frsight-footer-bg form .hs-form-required {\n  display: none !important;\n}\n\n.frsight-footer-bg .hs-form-field {\n  margin-bottom: 24px;\n}\n\n.frsight-footer-bg form .inputs-list>li {\n  display: block;\n  margin: .7rem 0;\n}\n\n.frsight-footer-bg ul li label input[type=\"checkbox\"],\n.frsight-footer-bg ul li label input[type=\"radio\"] {\n  opacity: 0;\n  display: none !important;\n}\n\n.frsight-footer-bg ul li label input[type=\"checkbox\"],\n.frsight-footer-bg .input ul li label span,\n.frsight-footer-bg ul li label input[type=\"radio\"] {\n  display: inline-block;\n  vertical-align: middle;\n  cursor: pointer;\n  position: relative;\n}\n\n.frsight-footer-form ul li label input[type=\"checkbox\"]+span:before,\n.frsight-footer-form ul li label input[type=\"radio\"]+span:before {\n  top: 4px;\n}\n\n.frsight-footer-form ul li label input[type=\"checkbox\"]:checked+span:before,\n.frsight-footer-form ul li label input[type=\"radio\"]:checked+span:before {\n  content: '\\f00c';\n}\n\n.frsight-footer-form ul li label input[type=\"checkbox\"]+span:before,\n.frsight-footer-form ul li label input[type=\"radio\"]+span:before {\n  color: #5bba7e;\n  content: ' ';\n  background: #e5e5e5;\n  border: 2px solid #ddd;\n  display: inline-block;\n  vertical-align: middle;\n  width: 20px;\n  height: 20px;\n  padding: 2px;\n  margin-right: 10px;\n  text-align: center;\n  font-family: FontAwesome;\n  line-height: 14px;\n  box-shadow: none;\n  position: absolute;\n  left: 0;\n  top: 3px;\n  font-size: 12px;\n  box-sizing: border-box;\n}\n\n.frsight-footer-bg label.hs-error-msg {\n  font-size: 14px;\n}\n\n.frsight-footer-bg label {\n  font-weight: 400;\n}\n\n.frsight-footer-bg form input[type=submit] {\n  background-color: #7bbd43;\n  width: 100%;\n  font-size: 19px;\n  box-shadow: none;\n  border: unset;\n  height: 55px;\n  border-radius: 3px;\n  border-top-left-radius: unset;\n  border-bottom-left-radius: unset;\n  border: 2px solid #7bbd43;\n}\n\n.frsight-footer-bg-left {\n  width: 30%;\n}\n\n.frsight-footer-bg .frsight-footer-logo {\n  max-width: 325px;\n}\n\n.frsight-footer-bg .frsight-footer-logo {\n  margin-bottom: 20px;\n}\n\n.frsight-footer-bg .frsight-footer-social {\n  margin-top: 25px;\n}\n\n.frsight-footer-bg .frsight-footer-social ul {\n  padding-left: 0;\n  display: inline-block;\n}\n\n.frsight-footer-bg .frsight-footer-social ul li {\n  list-style: none;\n  display: inline-block;\n  color: #7bbd43 !important;\n  padding-right: 10px;\n}\n\n.frsight-footer-bg .frsight-footer-social ul li a {\n  font-size: 22px;\n  color: #7bbd43 !important;\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 55px;\n  height: 55px;\n  border: 2px solid #fff;\n  border-radius: 22px;\n}\n\n.frsight-footer-social .fa {\n  color: #7bbd43;\n}\n\n.frsight-footer-bg-right.dis-flex {\n  width: 70%;\n  padding-left: 120px;\n}\n\n.frsight-footer-bg .frsight-footer-box:first-child {\n  padding-left: 0;\n}\n\n.frsight-footer-box {\n  width: 25%;\n  padding: 0px 20px;\n}\n\n.frsight-footer-bg .hs-menu-wrapper ul {\n  display: flex;\n  flex-wrap: wrap;\n  list-style: none;\n  margin: 0;\n  padding-left: 0;\n}\n\n.frsight-footer-bg .frsight-footer-box-menu ul li {\n  margin-bottom: 10px;\n  width: 100%;\n}\n\n.frsight-footer-bg h6 {\n  font-size: 25px;\n  font-weight: bold;\n  font-weight: 900;\n}\n\n.frsight-footer-bg .hs_submit.hs-submit {\n  width: 100%;\n  max-width: 144px;\n}\n\n.frsight-footer-bg .hs-prviacy_policy {\n  width: 100%;\n}\n\n@media screen and (max-width: 1850px) {\n\n  .frsight-footer-bg h6 {\n    font-size: 20px;\n  }\n}\n\n@media screen and (max-width: 1650px) {\n\n  .frsight-footer-bg form input[type=submit],\n  .frsight-footer-bg form input[type=email] {\n    height: 48px !important;\n  }\n\n  .frsight-footer-bg h6 {\n    font-size: 19px;\n  }\n}\n\n// Footer Fix\n.frsight-footer-bg .frsight-footertop-left {\n  padding-right: 50px;\n  width: 60%;\n}\n\n.frsight-footer-bg-inner.dis-flex {\n  padding-top: 85px;\n}\n\n.frsight-footer-bg {\n  padding: 60px 0px 185px 0px;\n}\n\n@media screen and (max-width: 1440px) {\n  .frsight-footertop .container {\n    max-width: 1240px !important;\n  }\n\n  // .frsight-footer-bg {\n  //     padding: 60px 0px 185px 0px;\n  // }\n  // .frsight-footer-bg .frsight-footertop-left {\n  //     padding-right: 50px;\n  //     width: 60%;\n  // }\n  .frsight-footer-bg p,\n  .frsight-footer-bg ul li,\n  .frsight-footer-bg ul li a {\n    font-weight: 300;\n    font-size: 16px;\n  }\n\n  // .frsight-footer-bg-inner.dis-flex {\n  //     padding-top: 85px;\n  // }\n  .frsight-footer-bg-right.dis-flex {\n    padding-left: 50px;\n  }\n\n  .frsight-footer-bg .container {\n    max-width: 1240px;\n    width: 100%;\n  }\n\n  .frsight-footer-bg h6 {\n    font-size: 18px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .frsight-footer-bg .frsight-footertop-left {\n    width: 100%;\n    padding-right: 0;\n    padding-bottom: 20px;\n  }\n\n  .frsight-footer-bg .frsight-footertop-right {\n    width: 100%;\n  }\n\n  .frsight-footer-bg-left {\n    width: 100%;\n  }\n\n  .frsight-footer-bg-right.dis-flex {\n    padding-left: 0;\n    padding-top: 20px;\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .frsight-footer-bg-inner.dis-flex {\n    padding-top: 60px;\n  }\n\n  .frsight-footer-bg {\n    padding: 60px 0px 80px 0px;\n  }\n\n  .frsight-footer-bg h6 {\n    font-size: 16px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .frsight-footer-bg .frsight-footertop-box {\n    width: 100%;\n    padding: 0;\n    padding-bottom: 20px;\n  }\n\n  .frsight-footer-box {\n    width: 100%;\n    padding: 0;\n    padding-bottom: 20px;\n  }\n\n  .frsight-footer-bg p,\n  .frsight-footer-bg ul li,\n  .frsight-footer-bg ul li a {\n    font-size: 18px;\n  }\n\n  .frsight-footer-bg {\n    padding: 60px 0px 60px 0px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .frsight-footer-bg .hs_email.hs-email.hs-fieldtype-text.field.hs-form-field {\n    width: 100%;\n    margin-bottom: 15px;\n  }\n}\n\n/* end footer */\n\n.cntnr-bg {\n  max-width: 2400px;\n  margin: 0 auto;\n  padding: 0 30px;\n  width: 100%;\n\n  @media screen and (max-width: 1240px) {\n    padding: 0 20px;\n  }\n}\n\n.frsight-hdr * {\n  font-family: Museo;\n\n  .frsight-demo-font {\n    font-family: $muso-500;\n  }\n}\n\n.cont {\n  padding-inline: 15px;\n  margin-inline: auto;\n  \n\n  @media screen and (min-width: 768px) {\n    width: 750px;\n  }\n\n  @media screen and (min-width: 992px) {\n    width: 970px;\n  }  \n\n  @media screen and (min-width: 1400px) {\n    width: 1350px;\n  }\n\n  @media screen and (min-width: 1600px) {\n    width: 1570px;\n    padding-inline: 20px;\n  }\n\n  @media screen and (max-width: 1850px) {\n    width: 1300px;\n    padding-inline: 15px;\n  }\n\n  @media screen and (max-width: 1440px) {\n    width: 1240px;\n  }\n  \n\n  @media screen and (max-width: 1200px) {\n    width: 100%;\n  }\n}\n\n.frsight-user-icon {\n  .crt-qty {\n    top: -16px;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n}\n\n// New Header\n\n.cmn__hdr-new{\n  position: relative;\n}\n\n.cmn__hdr-new .frsight-hdr-inner{\n  margin-inline: auto;\n  width: 1300px;\n  padding-inline: 20px;\n  \n  @media screen and (min-width: 1849px) {\n    width: 1570px;\n    padding-inline: 20px;\n  }\n\n  @media screen and (max-width: 1440px) {\n    // width: 100%;\n    // padding-inline: 40px;\n  }\n\n  @media screen and (max-width: 1199px) {\n    width: 100%;\n    padding-inline: 30px;\n  }\n}\n\n.cmn__hdr-new .frsight-hdr-inner.frsight-hdr-inner-indv{\n\n    @media screen and (min-width: 1849px) {\n      width: 1300px;\n      padding-inline: 20px;\n    }\n    \n    @media screen and (max-width: 1299px) {\n      padding-inline: 30px;\n    }\n  \n    @media screen and (max-width: 767px) {\n      padding-inline: 20px;\n    }\n  \n    @media screen and (max-width: 1199px) {\n      width: 100%;\n    }\n}\n\n.cmn__hdr-new .frsight-hdr{\n  background: #fff;\n}\n\n.cmn__hdr-new .cntnr-bg{\n  padding-inline: 0;\n}\n\n.cmn__hdr-new .bm-logo-img{\n  width: 234px;\n}\n\n.cmn__hdr-new .menu{\n  gap: 40px;\n\n  @media (max-width: 1299px){\n    gap: 20px;\n  }\n}\n\n.cmn__hdr-new .custom-menu-primary{\n  flex: 1;\n}\n\n.cmn__hdr-new .menu{\n  & > li{\n    padding-block: 31px !important;\n    margin-inline: 0 !important;\n  }\n\n  @media (max-width: 1080px){\n    gap: 0;\n  }\n}\n\n.cmn__hdr-new .menu > li:after{\n  display: none;\n}\n\n.cmn__hdr-new .menu > li > a{\n  display: block;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n  font-family: $muso-500 !important;\n  color: #666 !important;\n  line-height: 18px !important;\n  text-decoration: none !important;\n  transition: all 0.3s ease 0s;\n}\n\n.cmn__hdr-new .menu > li.hs-item-has-children > a{\n  padding-right: 21px !important;\n}\n\n.cmn__hdr-new .menu > li > a:hover{\n  color: #00add0 !important;  \n}\n\n.cmn__hdr-new .hs-item-has-children > a:after{\n  content: \"\" !important;\n  width: 11px;\n  height: 6px;\n  background-image: url(https://www.foursightonline.com/hubfs/2025/arrow_down.svg);\n  background-repeat: no-repeat;\n  position: absolute !important;\n  top: 50%;\n  left: auto !important;\n  right: 0 !important;\n  bottom: auto !important;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.cmn__hdr-new .frsight-hdr-right-box a{\n  display: inline-block;\n  padding: 0 2px;\n  text-align: center;\n  color: #666 !important;\n  text-decoration: none;\n  transition: .3s;\n  border-bottom: 1px solid transparent;\n\n  &.active {\n    border-color: #666;\n  }\n}\n\n.cmn__hdr-new .frsight-hdr-right-box a:hover{\n  border-color: #666;\n}\n\n.cmn__hdr-new .frsight-hdr-right-box a p{\n  font-size: 14px;\n  font-weight: 400 !important;\n  font-family: $muso-500 !important;\n  color: #666 !important;\n  line-height: 130%;\n}\n\n.cmn__hdr-new .frsight-hdr-right-box a:hover p{\n  color: #666 !important;\n}\n\n.cmn__hdr-new .frsight-hdr-cta{\n  margin-left: 40px !important;\n}\n\n.cmn__hdr-new .frsight-hdr-cta a{\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 400 !important;\n  font-family: $muso-500 !important;\n  justify-content: center;\n  line-height: 26px;\n  padding: 6px 24px;\n  letter-spacing: 0;\n  background-color: #69be28;\n  border: 1px solid #69be28;\n}\n\n.cmn__hdr-new .frsight-hdr-cta a:hover{\n  background-color: #00add0;\n  border-color: #00add0;\n}\n\n@media (max-width: 1080px){\n  .cmn__hdr-new .frsight-hdr-right{\n    display: flex;\n  }\n}\n\n@media (min-width: 1081px){\n  .cmn__hdr-new .hs-menu-children-wrapper{\n    max-width: 300px;\n    min-width: 120px !important;\n    background-color: var(--clr_white) !important;\n    box-shadow: 0 0 30px rgba(0, 0, 0, 0.05);\n    padding: 0 10px 7px;\n    position: absolute !important;\n    top: 100% !important;\n    left: 0 !important;\n    background: #fff !important;\n  }\n  \n  .cmn__hdr-new .hs-menu-children-wrapper li:not(:last-child) {\n    border-bottom: 1px solid #f1f1f1 !important;\n  }\n  \n  .cmn__hdr-new.frsight-hdr-top .hs-menu-children-wrapper li a{\n    color: var(--clr_gray) !important;\n    display: block !important;\n    font-size: 14px !important;\n    font-weight: 400 !important;\n    font-family: $muso-500 !important;\n    line-height: 18px !important;\n    text-decoration: none !important;\n    padding: 10px 0 !important;\n    transition: .3s;\n  }\n  \n  .cmn__hdr-new.frsight-hdr-top .hs-menu-children-wrapper li a:hover{\n    color: #00add0 !important;\n  }\n\n  .cmn__hdr-new{\n\n    .bm-logo-img{\n      padding-block: 18px;\n    }\n\n  }\n\n\n  \n\n}\n\n.gap-10 {\n  gap: 10px;\n}\n// New Footer\n\n.cmn__ftr-new{\n  background-color: #666;\n  // padding-block: 64px 38px;\n  padding-block: 30px 26px;\n}\n\n.cmn__ftr-new .container {\n  max-width: 1370px !important;\n  margin-inline: auto;\n  width: calc(100% - 48px);\n  padding: 0;\n}\n\n.cmn__ftr-new .footer__col, \n.cmn__ftr-new .footer__list {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.cmn__ftr-new .footer__top{\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n\n  @media (max-width: 1080px){\n    gap: 40px;\n  }\n}\n\n.cmn__ftr-new .footer__col {\n  width: 33.33%;\n\n  @media (max-width: 1080px){\n    width: 100%;\n  }\n}\n\n.cmn__ftr-new .footer__logo {\n  // max-width: 335px;\n  max-width: 327px;\n  width: 100%;\n\n  @media (max-width: 480px){\n    max-width: 210px;\n  }\n}\n\n.cmn__ftr-new .footer__logo{\n  width: 100%;\n}\n\n.cmn__ftr-new .footer__content {\n  font-size: 18px;\n  font-family: $muso-sans !important;\n  color: #fff;\n  line-height: 1.65;\n\n  @media (max-width: 480px){\n    font-size: 16px;\n  }\n}\n\n.cmn__ftr-new .footer__col:first-child {\n  max-width: 460px;\n\n  @media (max-width: 1080px){\n    max-width: none;\n  }\n}\n\n.cmn__ftr-new .footer__col:nth-child(2) {\n  max-width: 288px;\n\n  @media (max-width: 1080px){\n    max-width: none;\n  }\n}\n\n.footer__col:last-child {\n  max-width: 342px;\n\n  @media (max-width: 1080px){\n    max-width: none;\n  }\n\n}\n\n.cmn__ftr-new .footer__menu ul {\n  column-count: 2;\n  gap: 90px;\n  padding: 0;\n  margin: 0;\n}\n\n.cmn__ftr-new .footer__menu li {\n  display: block;\n  line-height: 1;\n  margin-bottom: 16px;\n}\n\n.cmn__ftr-new .footer__menu a {\n  color: #fff;\n  display: block;\n  font-size: 14px;\n  font-family: $muso-sans !important;\n  line-height: 18px;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.cmn__ftr-new .footer__menu a:hover{\n  text-decoration: underline;\n}\n\n.cmn__ftr-new .footer__title {\n  font-family: \"Abel\", sans-serif;\n  font-size: 24px;\n  color: #fff;\n  text-align: right;\n\n  @media (max-width: 1080px){\n    text-align: left;\n  }\n\n  @media (max-width: 480px){\n    font-size: 20px;\n  }\n}\n\n.cmn__ftr-new .footer__bottom {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  align-items: center;\n}\n\n.cmn__ftr-new .button_container {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  line-height: 1;\n\n  .button{\n    align-items: center;\n    background-color: #69be28;\n    border: 1px solid #69be28;\n    border-radius: 3px;\n    color: #fff;\n    display: inline-flex;\n    flex-wrap: wrap;\n    font-family: $muso-500;\n    font-size: 16px;\n    justify-content: center;\n    line-height: 26px;\n    min-width: 172px;\n    padding: 6px 24px;\n    text-align: center;\n    text-decoration: none;\n    transition: .3s;\n\n    &:hover{\n      background-color: #00add0;\n      border-color: #00add0;\n    }\n  }\n}\n\n.cmn__ftr-new .footer__social {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 19px;\n}\n\n.cmn__ftr-new .footer__social a {\n  align-items: center;\n  background-color: #d9d9d9;\n  border-radius: 50%;\n  display: flex;\n  height: 26px;\n  justify-content: center;\n  width: 26px;\n  transition: 0.3s;\n\n  &:hover{\n    background: #69be28;\n  }\n\n  svg{\n    height: auto;\n    width: 11px;\n    fill: #666;\n  }\n\n  &:hover svg{\n    fill: #fff;\n  }\n}\n\n.cmn__ftr-new .footer__legal {\n  color: #fff;\n  display: flex;\n  flex-wrap: wrap;\n  font-family: \"Abel\",sans-serif;\n  font-size: 14px;\n  margin-left: auto;\n\n  @media (max-width: 767px){\n    width: 100%;\n  }\n}\n\n.cmn__ftr-new .footer__legal * {\n  line-height: 18px;\n  position: relative;\n}\n\n.cmn__ftr-new .footer__legal > :not(:last-child) {\n  margin-right: 10px;\n  padding-right: 10px;\n}\n\n.cmn__ftr-new .footer__legal a {\n  color: inherit;\n  text-decoration: none;\n\n  &:hover{\n    text-decoration: underline;\n  }\n}\n\n.cmn__ftr-new .footer__legal > :not(:last-child):after {\n  background-color: #fff;\n  bottom: 2px;\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 2px;\n  width: 1px;\n}\n\n.cmn__ftr-new .footer__col form{\n  display: flex;\n\n  .hs-email{\n    flex: 1;\n    margin: 0;\n  }\n\n  input:not([type=\"submit\"]){\n    width: 100% !important;\n    background-color: #fff;\n    border-radius: 6px 0 0 6px;\n    font-size: 18px;\n    font-family: \"Abel\", sans-serif;\n    line-height: 30px;\n    padding: 4px 13px;\n    border: 1px solid #69be28;\n    border-right: 0;\n  }\n\n  input:placeholder{\n    color: #a9a9a9;\n    opacity: 1;\n  }\n\n  input:focus{\n    outline: none;\n  }\n\n  input[type=submit] {\n    border-radius: 0 6px 6px 0;\n    font-size: 18px;\n    line-height: 30px;\n    min-width: auto;\n    padding: 5px 23px;\n    background-color: #69be28;\n    border: 0;\n    color: #fff;\n    font-family: $muso-500 !important;\n    transition: 0.3s;\n    &:hover{\n      background: #00add0;\n      cursor: pointer;\n    }\n  }\n}\n\n// Product Content\n\n.products-grid{\n  display: none !important;\n}\n\n.product-section{\n  padding: 60px 0 56px !important;\n\n  @media (max-width: 767px){\n    padding: 40px 0 56px !important;\n  }\n\n  .container{\n    max-width: 1240px;\n  }\n\n  .prd-pic{\n    @media (max-width: 480px){\n      margin-bottom: 30px;\n    }\n  }\n\n  .prd-cnt{\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n\n    .title{\n      font-size: 48px;\n      font-family: $muso-500;\n      color: #666;\n      line-height: 104.167%;\n      margin: 0;\n\n      @media (max-width: 480px){\n        font-size: 36px;\n      }\n    }\n\n    .price{\n      font-size: 24px;\n      font-family: $muso-500;\n      line-height: 125%;\n      color: #666;\n    }\n\n    p{\n      font-size: 18px;\n      font-weight: 400;\n      font-family: $muso-500;\n      color: #666;\n      line-height: 166.667%;\n\n      a{\n        font-family: $muso-500;\n        color: #666;\n        text-decoration: underline;\n      }\n\n      @media (max-width: 480px){\n        font-size: 16px;\n      }\n    }\n\n    .btn{\n      min-width: 214px;\n      align-items: center;\n      background-color: #69be28;\n      border: 1px solid #69be28;\n      border-radius: 3px;\n      color: #fff;\n      display: inline-flex;\n      flex-wrap: wrap;\n      font-family: $muso-500;\n      font-size: 16px;\n      justify-content: center;\n      line-height: 26px;\n      min-width: 172px;\n      padding: 6px 24px;\n      text-align: center;\n      text-decoration: none;\n      transition: 0.3s;\n\n      &:hover{\n        background-color: #00add0;\n        border-color: #00add0;\n      }\n      \n    }\n  }\n\n}\n\n.book-demo {\n  position: relative;\n  z-index: 999;\n}\n\n.public_footer {\n  width: calc(83% - 220px);\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
